import React from 'react';
import { Helmet } from 'react-helmet';
import { Link as RouterLink } from "react-router-dom";
import { createBrowserHistory } from 'history';
import axios from "axios";
import Api from "../../../assets/js/utils/Api";
import Auth from "../../../assets/js/utils/Auth";
import { helper } from "../../../assets/js/utils/Element";
// import Config from "../../../../Config";
import Cookie from "../../../assets/js/utils/Cookie";
import PropTypes from "prop-types";
import BackgroundSlider from "../../components/Slider/BackgroundSlider";
import Button from "../../components/CustomButtons/Button";
import ReactTable from "react-table";
import LoaderComponent from "../../components/Loader";
import GridItem from "../../components/Grid/GridItem";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import DeleteFileModal from "../../components/User/DeleteFileModal";
import UploadFileModal from "../../components/User/UploadFileModal";
import ProcessingModal from "../../components/User/ProcessingModal";
import NewFolderModal from "../../components/User/NewFolderModal";
import CopyFilesModal from "../../components/User/SharedCopyFilesModal";
import MoveFilesModal from "../../components/User/SharedMoveFilesModal";
import RenameFileModal from "../../components/User/RenameFileModal";
import ShareModal from "../../components/User/ShareModal";
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import NewFileModal from "../../components/User/NewFileModal";
import Menu from '@material-ui/core/Menu';
import { MenuItem as MuiMenuItem } from '@material-ui/core';
import MaterialIcon from "@mdi/react";
import { mdiLinkVariant, mdiEyeOutline, mdiMessage, mdiMessageOutline, mdiLockOpenVariantOutline, mdiArrowExpandUp, mdiArrowCollapseDown } from '@mdi/js';
import { ChevronRight, Close as CloseIcon, Refresh as RefreshIcon, Check, AssessmentOutlined } from "@material-ui/icons";
import { ContextMenu, MenuItem, ContextMenuTrigger, showMenu } from "react-contextmenu";
import DragNDrop from "../../components/Drag/Drop";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import SearchInput from "../../components/User/SearchInput";
import OfficeFileModal from "../../components/User/OfficeFileModal";
import withStyles from "@material-ui/core/styles/withStyles";
import ImagePreviewModal from "../../components/User/imageModal";
// import PdfFileModal from "../../components/User/PdfFileModal";
import PdfViewModal from "../../components/User/PdfViewModal";
import NoPreviewModal from "../../components/User/NoPreviewModal";
import ActivitiesModal from "../../components/User/ActivitiesModal";
import NoteModal from "../../components/User/NoteModal";
import FileNoteModal from "../../components/User/FileNoteModal";
import ConfirmationModal from '../../components/User/ConfirmationModal.js';
import userHomePageStyle from "../../../assets/jss/user/userHomePageStyle.jsx";

const history = createBrowserHistory();

const UserShared = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        this.history = this.props.history;
        let path = helper.getParam("dir");
        if(path === null || path === "null"){
            path = "/";
        }
        // Keep the active tab (All / With You / With Others) in the URL so it
        // survives remounts (theme change, folder <-> root route switches).
        let filter = helper.getParam("tab");
        if(!filter || filter === "null"){
            filter = "all";
        }
        const backPath = this.getBackPath(path);
        let fileId = null;
        let transferId = null;
        const { match } = this.props.match;
        if(match && match.params.hasOwnProperty("id")){
            fileId = match.params.id;
        }
        if(match && match.params.hasOwnProperty("transferId")){
            transferId = match.params.transferId;
        }
        this.editDocRef = React.createRef();
        this.editDocTokenRef = React.createRef();
        this.editDocSecretRef = React.createRef();

        this.state = {
            limit: 200,
            totalItemCount: 0,
            response: null,
            cancelToken: null,
            page: 1,
            loading: false,
            loadingMore: false,
            totalPages: 1,
            checked: [],
            path: decodeURIComponent(path.trim()),
            backPath: backPath,
            deleteFileModal: false,
            uploadFileModal: false,
            favourites: [],
            shareFileModal: false,
            sharingFiles: false,
            downloadModal: false,
            downloadingFiles: false,
            downloadUrl: "",
            downloadFile: false,
            file: null,
            newFolderModal: false,
            creatingFolder: false,
            copyFilesModal: false,
            copyingFilesModal: false,
            moveFilesModal: false,
            movingFilesModal: false,
            renameFileModal: false,
            renamingFileModal: false,
            files: [],
            errorMessage: null,
            fileId: fileId,
            rootPrivacy: null,
            transferId: transferId,
            currentFile: null,
            filter: filter,
            searchFormData: this.defaultSearchFormData(),
            ownerNotification: '',
            groupNotification: '',
            ownerId: null,
            canTrackPdf: false,
            sharedWith: [],
            showError: false,
            newLinkUploaded: false,
            officeFileModal: false,
            officeFileAction: "view",
            uploadMenuEl: null,
            docMenuEl: null,
            newFileModal: false,
            newFileExtension: null,
            creatingFile: false,
            newFileError: false,
            newFileErrorMessage: null,
            newUser: null,
            saving: false,
            imagePreviewModal: false,
            pdfFileModal: false,
            noPreviewModal: false,
            activitiesModal: false,
            activities: [],
            activitiesFileId: null,
            noteModal: false,
            noteSavingModal: false,
            fileNoteModal: false,
            uploadType: 'file',
            fileActionsMenuEl: null,
            pdfTrackingModal: false
        };

        this.loadingFolder = false;
        this.onShareModal = this.onShareModal.bind(this);
        this.onShareModalSuccess = this.onShareModalSuccess.bind(this);
        this.onAdvShareModal = this.onAdvShareModal.bind(this);
        this.closeSnackbar = this.closeSnackbar.bind(this);
    }
    componentDidMount(){
        const { authorized, user } = this.store.getState();
        if(!authorized && !Auth.hasAccessToken()){
            const location = this.history.location;
            const loginRequired = "/auth/login?return="+encodeURIComponent(location.pathname+location.search);
            this.history.push(loginRequired);
            return;
        }
        if(authorized){
            if(user.agreement_login === 0){
                this.history.push("/agreement/policy");
                return;
            }

            this.loadFiles();
        }
    }
    componentWillUnmount(){
        if (this.state.cancelToken) {
            this.state.cancelToken.cancel('Request Cancelled')
        }
    }
    defaultSearchFormData(){
        return {
            search: '',
            fileName: '',
            searchIn: 'shared',
            attachmentContains: '',
            from: '',
            to: '',
            subject: '',
            destination: '',
            startDate: '',
            endDate: '',
            expiryStartDate: '',
            expiryEndDate: '',
        }
    }
    closeSnackbar(){
        this.setState({showError: false});
    }
    clearSearch(){
        this.setState({
            searchFormData: this.defaultSearchFormData()
        }, () => {
            this.loadFiles()
        });
    }
    onSearchInputSuccess(searchData){
        this.setState({
            searchFormData: {
                search: searchData.search,
                fileName: searchData.fileName,
                searchIn: 'shared',
                attachmentContains: searchData.attachmentContains,
                from: searchData.from,
                to: searchData.to,
                subject: searchData.subject,
                destination: searchData.destination,
                startDate: searchData.startDate,
                endDate: searchData.endDate,
                expiryStartDate:  searchData.expiryStartDate,
                expiryEndDate:  searchData.expiryEndDate,
            }
        }, () => {
            this.loadFiles();
        });
    }
    getBackPath(path){
        if(typeof(path) !== "string" || path.trim().length <= 0){
            return "";
        }
        if(path.length <= 1 || path.trim() === "/"){
            return "";
        }
        if(path.substr(0, 1) !== "/"){
            path += "/";
        }
        path = decodeURIComponent(path.trim()); //Decode path
        path = path.replace(/^\/+|\/+$/g, ''); //Remove trailing slash
        const pathArray = path.split("/");
        pathArray.pop();
        let backPath = pathArray.join("/");
        if(backPath.length <= 0){
            backPath = "/";
        }
        return backPath;
    }
    loadFiles(viewMore = false, newPath = null, backPath = "", file = null, filter = null){
        const source = axios.CancelToken.source();
        let { page, path, favourites, fileId, transferId, searchFormData } = this.state;
        if(viewMore){
            page += 1;
        }else{
            page = 1;
        }
        if(filter === null){
            filter = this.state.filter;
        }
        let requestData = {
            page: page,
            limit: 200,
            shareViewType: filter
        };
        if(path === "/" && newPath !== null){
            path = "";
        }
        requestData['path'] = path;
        if(newPath !== null){
            path += "/"+newPath;
            requestData['path'] = path;
        }
        if(backPath !== ""){
            requestData['path'] = path = backPath;
        }
        backPath = this.getBackPath(path);
        let url = "/user/shared";
        if(file !== null){
            fileId = file.id;
        }
        if(path === "/" || path === ""){
            fileId = null;
        }
        if(fileId !== null){
            requestData['file_id'] = fileId;
            url += "/"+fileId;
        }
        if(transferId !== null){
            requestData['transferId'] = transferId;
        }

        // search for request data
        if(searchFormData.search || searchFormData.fileName){
            requestData['name'] = searchFormData.fileName ? searchFormData.fileName : searchFormData.search;
        }
        if(searchFormData.startDate){
            requestData['startDate'] = searchFormData.startDate;
        }
        if(searchFormData.endDate){
            requestData['endDate'] = searchFormData.endDate;
        }

        history.push(url+"?dir="+encodeURIComponent(path)+"&tab="+filter);
        Api.getSharedFiles(requestData, source).then(data => {
            const oldResponse = (viewMore ? this.state.response:[]);
            const response = oldResponse.concat(data.response);
            data.response.map(file => {
                if(file.favourite){
                    favourites.push(file.id);
                }
                return null;
            });
            this.setState({
                totalItemCount: data.totalItemCount,
                response: response,
                loading: false,
                loadingMore: false,
                totalPages: data.totalPages,
                favourites: favourites,
                rootPrivacy: data.privacy,
                ownerNotification: ( data.ownerNotification ? data.ownerNotification : ''),
                groupNotification: ( data.groupNotification ? data.groupNotification : ''),
                ownerId: ( data.owner_id ? data.owner_id : null),
                sharedWith: ( data.sharedWith ? data.sharedWith : []),
                canTrackPdf: (data.hasOwnProperty('can_track_pdf') ? data.can_track_pdf : false)
            });
            this.loadingFolder = false;
        }).catch(err => {
            console.log(err);
            if(err.message !== "Request Cancelled"){
                this.setState({
                    loading: false,
                    showError: true,
                    errorMessage: err.message,
                    rootPrivacy: "",
                    files: [],
                    response: null
                });
            }
        });
        this.setState({
            loading: (!viewMore), 
            loadingMore: viewMore,
            showError: false, 
            cancelToken: source,
            page: page,
            path: path,
            backPath: backPath,
            checked: viewMore ? this.state.checked : [],
            uploadFileModal: false,
            newFolderModal: false,
            creatingFolder: false,
            copyFilesModal: false,
            copyingFilesModal: false,
            moveFilesModal: false,
            movingFilesModal: false,
            renameFileModal: false,
            renamingFileModal: false,
            files: [],
            errorMessage: null,
            fileId: fileId,
            transferId: null,
            filter: filter,
            checkedAll: false,
            noteModal: false,
            noteSavingModal: false,
            fileNoteModal: false,
            pdfTrackingSavingModal: false,
            pdfTrackingModal: false
        });
        this.loadingFolder = true;
    }
    renderErrorMessages(){
        const { errorMessage } = this.state;
        if(typeof(errorMessage) === "object"){
            let errorMessages = [];
            let key = 0;
            for(const attrib in errorMessage){
                const message = errorMessage[attrib];
                errorMessages.push(<div key={key} className={"form-error-message passwordCheck-notValid-customizable"}>
                    <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
                    <span className="checkPasswordText-lowerletter">{message}</span>
                </div>);
                key++;
            }
            return errorMessages;
        }
        return <div className={"form-error-message passwordCheck-notValid-customizable"}>
            <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
            <span className="checkPasswordText-lowerletter">{errorMessage}</span>
        </div>;
    }
    handleToggle(file, onContextMenu = false) {
        if(this.loadingFolder){
            return;
        }
        // if(file.default){
        //     return;
        // }

        let newChecked = [];
        if(onContextMenu){
            newChecked = [file.id];
        }else{
            const { checked } = this.state;
            const currentIndex = checked.indexOf(file.id);
            newChecked = [...checked];
        
            if (currentIndex === -1) {
                newChecked.push(file.id);
            } else {
                newChecked.splice(currentIndex, 1);
            }
        }
    
        const downloadFile = (newChecked.length === 1 && file.type === "file");
        this.setState({
            checked: newChecked,
            downloadFile: downloadFile,
            file: (downloadFile ? this.getCheckedFile(newChecked) : null)
        });
    }
    openFileModal(file){
        if(this.loadingFolder){
            return;
        }
        // Preview is only allowed for read/download/upload/write (and owner).
        if(file.type === "file" && !this.canPreviewFile(file)){
            return;
        }
        const { user } = this.store.getState();
        let newChecked = [file.id];
        const downloadFile = (newChecked.length === 1 && file.type === "file");
        this.setState({
            checked: newChecked,
            downloadFile: downloadFile,
            file: (downloadFile ? this.getCheckedFile(newChecked) : null)
        },() => {
            if(helper.hasThumbnail(file)){
                this.onImagePreviewModal(true);
            }else if(helper.isExtensionAllowed(user, 'ms_office') && helper.isExtensionEnable(user, 'ms_office') && helper.isOfficeDocument(file)){
                this.onOfficeFileModal('view');
            }else if(helper.isPdfDocument(file)){
                this.onPdfFileModal(true);
            }else{
                this.onNoPreviewModal(true)
            }
        });
    }
    onActivityModal(status = false, activitiesFileId = null, activities = []){
        this.setState({
            activitiesModal: status,
            activities: activities,
            activitiesFileId: activitiesFileId
        });
    }
    getTableData(){
        const { classes } = this.props;
        const { response, checked, backPath } = this.state;
        const { user } = this.store.getState();

        if(response === null){
            return [];
        }
        let tableData = [];
        if(backPath.length > 0 && false){
            let fileArray = {
                id: 0,
                check: "",
                orignalName: "",
                name: (
                    <Link href="/user/shared" onClick={(e) => {e.preventDefault(); this.loadFiles(false, null, backPath);}}>
                        <Button justIcon color="transparent" className={classes.fileIcon}>
                             { helper.getFolderIcon() }
                        </Button>
                        {"..."}
                    </Link>
                ),
                notes: "",
                orignalSize: "",
                size: "",
                date: "",
                owner: "",
                lastModifiedBy: "",
                activity: "",
                recipients: "",
                selectMenu: ""
            };
            tableData.push(fileArray);
        }
        response.map(file => {
            if(file.type === "folder" && file.path === "/Web/My Docs"){
                return null;
            }
            let fileArray = {
                id: file.id,
                default: file.default,
                orignalName: file.name,
                name: (
                    <ContextMenuTrigger id="file_dropdown_menu" collect={() => {return file}}>
                        {this.getFileName(file)}
                    </ContextMenuTrigger>
                ),
                notes: (
                    file.note ?
                        <div onClick={() => this.onFileNoteModal(true)}>
                            <MaterialIcon path={mdiMessage} className="MuiSvgIcon-root" />
                        </div>
                    :
                        <></>
                ),
                type: file.type,
                downloadLink: file.downloadLink,
                check: (
                    <Checkbox
                        tabIndex={-1}
                        checked={checked.includes(file.id)}
                        className={classes.positionAbsolute}
                        onClick={() => this.handleToggle(file)}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        disabled={(file.default === 1)}
                        classes={{
                            checked: classes.checked,
                            root: classes.checkRoot
                        }}
                    />
                ),
                orignalSize: file.orignalSize,
                size: file.size,
                date: file.modified_date,
                owner: file.owner,
                lastModifiedBy: file.last_modified_by,
                activity: (
                    <>
                        <span>{ this.getActivityText(file.activity) }</span>
                        {
                            file.activity.length <= 0 ?
                                <></>
                            :
                                <Button color="transparent" simple onClick={() => this.onActivityModal(true, file.id, file.activities)}>
                                    More...
                                </Button>
                        }
                    </>
                ),
                selectMenu: (
                    <div className='file-menu-icon' onClick={(e) => this.handleLeftMenuClick(e, file)}>
                        <svg width="6" height="22" viewBox="0 0 6 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.75 16.5C2.38533 16.5 2.03559 16.6449 1.77773 16.9027C1.51987 17.1606 1.375 17.5103 1.375 17.875C1.375 18.2397 1.51987 18.5894 1.77773 18.8473C2.03559 19.1051 2.38533 19.25 2.75 19.25C3.11467 19.25 3.46441 19.1051 3.72227 18.8473C3.98013 18.5894 4.125 18.2397 4.125 17.875C4.125 17.5103 3.98013 17.1606 3.72227 16.9027C3.46441 16.6449 3.11467 16.5 2.75 16.5ZM2.75 9.625C2.38533 9.625 2.03559 9.76987 1.77773 10.0277C1.51987 10.2856 1.375 10.6353 1.375 11C1.375 11.3647 1.51987 11.7144 1.77773 11.9723C2.03559 12.2301 2.38533 12.375 2.75 12.375C3.11467 12.375 3.46441 12.2301 3.72227 11.9723C3.98013 11.7144 4.125 11.3647 4.125 11C4.125 10.6353 3.98013 10.2856 3.72227 10.0277C3.46441 9.76987 3.11467 9.625 2.75 9.625ZM4.125 4.125C4.125 3.76033 3.98013 3.41059 3.72227 3.15273C3.46441 2.89487 3.11467 2.75 2.75 2.75C2.38533 2.75 2.03559 2.89487 1.77773 3.15273C1.51987 3.41059 1.375 3.76033 1.375 4.125C1.375 4.48967 1.51987 4.83941 1.77773 5.09727C2.03559 5.35513 2.38533 5.5 2.75 5.5C3.11467 5.5 3.46441 5.35513 3.72227 5.09727C3.98013 4.83941 4.125 4.48967 4.125 4.125Z"/>
                        </svg>
                    </div>
                )
            };
            if(user.id === file.owner_id){
                fileArray.folderPath = file.folder_path;
            }
            if(user.level_id !== 5){
                fileArray.recipients = <div className={classes.recipients}>{this.getRecipients(file)}</div>;
                fileArray.relatedLinks = this.getRelatedLink(file);
            }
            tableData.push(fileArray);
            return null;
        });
        return tableData;
    }
    getActivityText(activity){
        const { user } = this.store.getState();
        
        let activityText = "";
        if(activity.length <= 0){
            return activityText;
        }

        if(user.id === activity.owner_id){
            activityText += "You ";
        }else{
            activityText += activity.owner_name+" ";
        }

        let actionText = "";
        let action = activity.action.toLowerCase();
        switch(action){
            case 'upload':
                actionText = 'uploaded';
                break;
            case 'rename':
                actionText = 'renamed';
                break;
            case 'copy':
                actionText = 'copied';
                break;
            case 'delete':
                actionText = 'deleted';
                break;
            case 'move':
                actionText = 'moved';
                break;
            case 'downloaded document(s)':
                actionText = 'downloaded';
                break;
            case 'updated document(s)':
                actionText = 'updated';
                break;
            default:
                actionText = action;
                break;
        }

        activityText += actionText+' '+activity.file_name;

        return activityText;
    }
    getFileName(file){
        const { classes } = this.props;
        const { favourites } = this.state;
        const { user } = this.store.getState();
        
        return (
            <div title={file.name} onDoubleClick={(e) => this.openFileModal(file)} className='file-name'>
                <div>
                    <Button justIcon color="transparent" className={classes.fileIcon}>
                        {
                            file.privacy === "write" || file.owner_id === user.id ?
                                <MaterialIcon path={mdiLockOpenVariantOutline} className="privacy-icon" title="Full Access" />
                            : file.privacy === "upload" ?
                                <MaterialIcon path={mdiArrowExpandUp} className="privacy-icon" title="Uploads Allowed" />
                            : file.privacy === "download" ?
                                <MaterialIcon path={mdiArrowCollapseDown} className="privacy-icon" title="Download" />
                            : (file.privacy === "read" || file.privacy === "view") ?
                                <MaterialIcon path={mdiEyeOutline} className="privacy-icon" title={file.privacy === "view" ? "View Only" : "Preview Only"} />
                            :
                                <></>
                        }
                    </Button>
                    {
                        file.type === "folder" ?
                            <Link href="/user/shared" onClick={(e) => this.loadFolder(e, file)}>
                                <Button justIcon color="transparent" className={classes.fileIcon}>
                                    {
                                        file.hasOwnProperty("sharedWith") && file.sharedWith.length > 0 ?
                                            helper.getFolderIcon(true)                               
                                        :
                                            helper.getFolderIcon()                                                                
                                    }
                                </Button>
                                {file.name}
                            </Link>
                        :
                            <>
                                { 
                                    helper.getFileIcon(file, classes, true)
                                }
                                {file.name}
                            </>
                            
                    }
                </div>
                {
                    user.level_id !== 5 ? 
                        <Button justIcon color="transparent" className={classes.fileIcon+" star-icon"} onClick={() => this.favourite(file)}>
                            {
                                favourites.includes(file.id) ?
                                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.31605 0.511466C8.1655 0.198904 7.84735 0 7.49796 0C7.14857 0 6.83326 0.198904 6.67987 0.511466L4.85336 4.27074L0.774248 4.87314C0.433375 4.92428 0.149315 5.16297 0.0442125 5.48974C-0.0608899 5.81651 0.0243281 6.17737 0.26862 6.4189L3.22853 9.34846L2.52974 13.4885C2.47293 13.8295 2.61496 14.1761 2.89618 14.3779C3.1774 14.5796 3.54952 14.6052 3.8563 14.4432L7.5008 12.4968L11.1453 14.4432C11.4521 14.6052 11.8242 14.5825 12.1054 14.3779C12.3866 14.1733 12.5287 13.8295 12.4719 13.4885L11.7702 9.34846L14.7301 6.4189C14.9744 6.17737 15.0625 5.81651 14.9545 5.48974C14.8466 5.16297 14.5654 4.92428 14.2245 4.87314L10.1426 4.27074L8.31605 0.511466Z"/>
                                    </svg>                        
                                :
                                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.75357 4.79753L7.49833 1.20222L9.24309 4.79753C9.37381 5.06753 9.62955 5.25511 9.92793 5.30059L13.8323 5.87754L10.9964 8.68557C10.7861 8.89305 10.6895 9.19147 10.7406 9.48421L11.4084 13.449L7.92742 11.5874C7.66031 11.4453 7.3392 11.4453 7.06925 11.5874L3.58541 13.449L4.25319 9.48421C4.3015 9.19147 4.20773 8.89589 3.99745 8.68557L1.16434 5.87754L5.06874 5.30059C5.36711 5.25796 5.62286 5.06753 5.75357 4.79753ZM11.3914 14.4693C11.6215 14.5915 11.9 14.5745 12.1103 14.421C12.3206 14.2675 12.4286 14.0089 12.3859 13.7531L11.6386 9.33358L14.7985 6.20154C14.9832 6.01965 15.0457 5.74964 14.9661 5.50522C14.8866 5.2608 14.6734 5.08174 14.4177 5.04195L10.0615 4.39963L8.11213 0.383689C7.99846 0.147791 7.75976 0 7.49833 0C7.2369 0 6.99821 0.147791 6.88454 0.383689L4.93518 4.39963L0.58181 5.04479C0.326063 5.08174 0.112941 5.2608 0.0333752 5.50806C-0.0461904 5.75533 0.0191671 6.02249 0.201031 6.20439L3.35808 9.33358L2.61357 13.7531C2.57095 14.0089 2.67609 14.2675 2.88921 14.421C3.10233 14.5745 3.38081 14.5915 3.60814 14.4693L7.50118 12.3889L11.3942 14.4693H11.3914Z"/>
                                    </svg>
                            }
                        </Button>
                    :
                        <></>
                }
            </div>
        )
    }
    getRecipients(file){
        if(file.transfer_type === "share"){
            return <div>Anyone (links only)</div>;
        }
        if(file.recipients.length <= 2){
            return <div>{file.recipients.join(",")}</div>;
        }
        const firstTwoRecipients = file.recipients.slice(0, 2);
        let recipientsList = [];
        file.recipients.map((email, key) => {
            recipientsList.push(
                <li key={key}>{email}</li>
            );
            return null;
        });
        return (
            <>
                <div>
                    {firstTwoRecipients.join(",")}
                </div>
                <ul>
                    {recipientsList}
                </ul>
            </>
        );
    }
    getRelatedLink(file){
        if(file.relatedLinks.length <= 0){
            return null;
        }
        const url = "/user/links?page=1&links="+file.relatedLinks.join(",");
        return (
            <RouterLink to={url}>
                <MaterialIcon path={mdiLinkVariant} className="MuiSvgIcon-root" />
            </RouterLink>
        );
    }
    loadFolder(e, parent){
        e.preventDefault();
        const { fileId } = this.state;
        if(fileId === null){
            this.loadFiles(false, parent.name, "", parent);
        }else{
            this.loadFiles(false, parent.name);
        }
    }
    getTrProps(state, rowInfo){
        if (rowInfo && rowInfo.row) {
            // const { checked } = this.state;
            return {
                onClick: (e) => this.handleToggle(rowInfo.original),
                // style: {
                //     background: checked.includes(rowInfo.original.id) ? 'rgba(0, 0, 0, 0.7)' : 'transparent',
                // }
            }
        }else{
            return {}
        }
    }
    getTrGroupProps(state, rowInfo){
        const { backPath, checked } = this.state;
        if(backPath.length <= 0){
            return {};
        }
        if (rowInfo && rowInfo.row) {
            if(checked.indexOf(rowInfo.original.id) !== -1){
                return {
                    className: 'selected_row'
                }
            }
            return {
                className: (rowInfo.original.id === 0 ? 'frozen_row' : '')
            }
        }else{
            return {}
        }
    }
    deleteSelected(){
        const { checked } = this.state;
        if(checked.length <= 0){
            return;
        }
        this.setState({deleteFileModal: true});
    }
    onModalClose(deleteFileModal = true){
        let checked = this.state.checked;
        if(deleteFileModal === false){
            checked = [];
        }
        this.setState({
            deleteFileModal: deleteFileModal,
            checked: checked,
            deleteAll: false
        });
    }
    onModalSuccess(){
        const { checked, response, fileId } = this.state;
        const source = axios.CancelToken.source();
        const requestData = {
            files: checked,
        };
        if(fileId !== null){
            requestData['sharedFileId'] = fileId;
        }

        Api.deleteFiles(requestData, source).then(data => {
            let newResponse = [];
            response.map(file => {
                if(!checked.includes(file.id)){
                    newResponse.push(file);
                }
                return null;
            });
            this.setState({
                response: newResponse,
                checked: [],
                deleteFileModal: false,
                deleteAll: false,
                saving: false,
                errorMessage: null
            });
        }).catch(err => {
            this.setState({
                saving: false,
                errorMessage: err.message
            });
        });
        this.setState({
            saving: true
        });
    }
    onUploadModal(uploadFileModal = true, type = 'file'){
        if(!uploadFileModal){
            this.loadFiles(false);
            return;
        }
        this.setState({
            uploadFileModal: uploadFileModal,
            uploadType: type,
            uploadMenuEl: null,
        });
    }
    onUploadModalSuccess(){
        this.loadFiles(false);
    }
    favourite(file){
        const { favourites } = this.state;
        const currentIndex = favourites.indexOf(file.id);
        const newFavourites = [...favourites];
    
        if (currentIndex === -1) {
            newFavourites.push(file.id);
        } else {
            newFavourites.splice(currentIndex, 1);
        }

        const source = axios.CancelToken.source();
        const requestData = {
            file_id: file.id
        }
        Api.favouriteFile(requestData, source).then(data => {
            
        }).catch(err => {
            console.log(err);
        });
        this.setState({
            favourites: newFavourites
        }, () => {
            this.handleToggle(file);
        });
    }
    onShareModal(status = false){
        const { checked, path, currentFile } = this.state;
        if(checked.length <= 0){
            return;
        }
        
        const source = axios.CancelToken.source();
        const requestData = {
            files: checked,
            path: path
        };
        if(typeof(path) === "string" && path.indexOf("/Web/My Docs") !== -1){
            requestData['uploadType'] = "my_docs";
        }

        if(currentFile !== null){
            requestData['sharedFileId'] = currentFile.id;
        }
        
        Api.shareFiles(requestData, source).then(data => {
            if(data.status === 'uploaded'){
                this.setState({
                    sharingFiles: false,
                    newLinkUploaded: true
                })

                return;
            }

            this.setState({sharingFiles: false, downloadUrl: data.downloadUrl});
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({cancelToken: null, errorMessage: err.message, sharingFiles: false});
            }
        });
        this.setState({
            shareFileModal: status,
            sharingFiles: status,
            cancelToken: source
        });
    }
    onAdvShareModal(status = false){
        const { checked } = this.state;
        if(checked.length <= 0){
            return;
        }
        
        this.setState({
            advShareModal: status,
        });
        if(!status){
            this.loadFiles();
        }
    }
    onShareModalSuccess(){
        this.setState({
            shareFileModal: false,
            errorMessage: null,
            newLinkUploaded: false
        });

        // const { downloadUrl } = this.state;
        // if(downloadUrl.length > 0){
        //     window.location.href = downloadUrl;
        // }
        this.history.push("/user/links");
    }
    onDownloadModal(status = false){
        const { checked, path, downloadFile, file, fileId, rootPrivacy } = this.state;
        if(checked.length <= 0){
            return;
        }
        // Block the download action unless the current permission allows it.
        // (status === false only closes the modal, so let that through.)
        if(status !== false && !this.isDownloadAllowed()){
            return;
        }

        if(downloadFile && checked.length === 1 && file){
            window.location.href = file.downloadLink;
            this.trackFileDownload();
            return;
        }

        let source = null;
        if(status){
            source = axios.CancelToken.source();
            const requestData = {
                files: checked,
                path: path
            };
            if(fileId !== null){
                requestData['sharedFileId'] = fileId;
            }else if(checked.length > 0){
                requestData['sharedFileId'] = checked[0];
            }
            Api.downloadFiles(requestData, source).then(data => {
                let state = {
                    downloadingFiles: false, 
                    downloadUrl: data.downloadUrl
                }

                if(rootPrivacy !== null && rootPrivacy !== "" && rootPrivacy === 'read'){
                    state['downloadModal'] = false;
                    state['errorMessage'] = null;
                }

                this.setState(state, () => {
                    if(rootPrivacy !== null && rootPrivacy !== "" && rootPrivacy === 'read' && this.state.downloadUrl.length > 0){
                        window.location.href = this.state.downloadUrl;
                        this.trackFileDownload();
                    }
                });
            }).catch(err => {
                if(err && err.message !== "Request Cancelled"){
                    this.setState({cancelToken: null, errorMessage: err.message, downloadingFiles: false});
                }
            });
        }

        this.setState({
            downloadModal: status,
            downloadingFiles: status,
            cancelToken: source
        });
    }
    trackFileDownload(){
        const { fileId, checked } = this.state;
        if(checked.length <= 0){
            return;
        }
        const source = axios.CancelToken.source();
        const requestData = {
            id: checked,
            file_id: fileId,
        };
        Api.trackFileDownload(requestData, source).then(data => {
            //Silent
        }).catch(err => {
            //Silent
        });
    }
    onDownloadModalSuccess(){
        this.setState({
            downloadModal: false,
            errorMessage: null
        });
        const { downloadUrl } = this.state;
        if(downloadUrl.length > 0){
            window.location.href = downloadUrl;
            this.trackFileDownload();
        }
    }
    getNoDataProps(){
        return { style: { display: 'none' } };
    }
    getBreadCrumbs(){
        let { path, rootPrivacy } = this.state;
        let breadcrumbs = [{
            value: "/",
            label: "Home"
        }];
        if(path === "/"){
            return breadcrumbs;
        }
        if(path.substr(0,1) === "/"){
            path = path.substr(1);
        }
        const pathArray = path.split("/");
        let newPath = "";
        pathArray.map(path => {
            newPath += "/"+path;
            let pathLabel = path;
            if(rootPrivacy !== null && rootPrivacy !== ""){
                const privacyLabel = helper.getSharePrivacyLabel(rootPrivacy);
                if(privacyLabel !== ""){
                    pathLabel += " (" + privacyLabel + ")";
                }
            }
            breadcrumbs.push({
                value: newPath,
                label: pathLabel
            });
            return null;
        });
        return breadcrumbs;
    }
    onNewFolderModal(status = false){
        this.setState({
            docMenuEl: null,
            newFolderModal: status,
        });
    }
    onNewFolderModalSuccess(folderName){
        const source = axios.CancelToken.source();
        this.setState({
            creatingFolder: true,
            cancelToken: source,
        });
        const { fileId } = this.state;
        const requestData = {
            folderName: folderName,
            path: this.state.path
        };
        if(fileId !== null){
            requestData['sharedFileId'] = fileId;
        }
        Api.addNewFolder(requestData, source).then(data => {
            this.loadFiles();
        }).catch(err => {
            console.log(err);
        });
    }
    getColumns(){
        const { user } = this.store.getState();
        const modificationAllowed = this.isModificationAllowed();
        let columns = [
            {
                Header: "",
                accessor: "check",
                sortable: false,
                filterable: false,
                headerClassName: "hd_check",
                className: "hd_check td_check",
                resizable: false
            },
            {
                Header: "Name",
                accessor: "orignalName",
                headerClassName: "hd_name hd_show_head",
                className: "hd_name td_name td_hide",
                resizable: false
            },
            {
                Header: "Name",
                accessor: "name",
                headerClassName: "hd_name hd_hide",
                className: "hd_name td_name",
            },
            {
                Header: "Last Modified",
                accessor: "date",
                headerClassName: "hd_creation_date",
                className: "hd_creation_date td_creation_date",
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                  if(a1<b1)
                    return 1;
                  else if(a1>b1)
                    return -1;
                  else
                    return 0;
                }
            },
            {
                Header: "Size",
                accessor: "orignalSize",
                headerClassName: "hd_size hd_show_head",
                className: "hd_size td_size td_hide",
                resizable: false
            },
            {
                Header: "Size",
                accessor: "size",
                headerClassName: "hd_size hd_hide",
                className: "hd_size td_size",
            },
            {
                Header: "Creator",
                accessor: "owner",
                headerClassName: "hd_owner",
                className: "hd_owner td_owner",
            },
        ];
        if(user.level_id !== 5){
            columns.push({
                Header: "Related Links",
                accessor: "relatedLinks",
                headerClassName: "hd_related_links",
                className: "hd_related_links td_creation_date",
            });
        }
        columns.push({
            Header: "Notes",
            accessor: "notes",
            headerClassName: "hd_notes hd_notes",
            className: "hd_notes td_notes",
        });
        if(user.level_id !== 5){
            const { path } = this.state;
            if(path !== "/" && path !== "/Computer" && path !== "/Computer/Outlook" && path !== "/Computer/App" && path !== "/Web/My Docs"){
                columns.push({
                    Header: "Recipient(s)",
                    accessor: "recipients",
                    headerClassName: "td_recipients",
                    className: "hd_recipients td_recipients",
                });
            }
        }
        columns.push({
            Header: "Last Modified By",
            accessor: "lastModifiedBy",
            headerClassName: "hd_owner",
            className: "hd_owner td_owner",
        });
        if(!modificationAllowed){
            columns.push({
                Header: "Activity",
                accessor: "activity",
                headerClassName: "hd_activity",
                className: "hd_activity td_activity",
            });
        }
        columns.push({
            Header: "Folder Path",
            accessor: "folderPath",
            headerClassName: "hd_path",
            className: "hd_path td_path",
        });
        columns.push({
            Header: "",
            accessor: "selectMenu",
            headerClassName: "hd_select_menu",
            className: "hd_select_menu td_select_menu",
            sortable: false,
            filterable: false,
            resizable: false
        });

        return columns;
    }
    onContextMenuItemClick(type, data){
        const checkedFile = this.getCheckedFile();
        switch(type){
            case 'share':
                if(!this.isModificationAllowed()){ break; }
                this.onShareModal(true);
                break;
            case 'delete':
                if(!this.isModificationAllowed()){ break; }
                this.deleteSelected();
                break;
            case 'download':
                if(!this.isDownloadAllowed()){ break; }
                this.onDownloadModal(true);
                break;
            case 'copy':
                if(!this.isModificationAllowed()){ break; }
                this.onCopyModal(true);
                break;
            case 'move':
                if(!this.isModificationAllowed()){ break; }
                this.onMoveModal(true);
                break;
            case 'rename':
                if(!this.isModificationAllowed()){ break; }
                this.onRenameModal(true);
                break;
            case 'permission':
                this.onAdvShareModal(true);
                break;
            case 'view':
                if(checkedFile !== null && !this.canPreviewFile(checkedFile)){ break; }
                this.onOfficeFileModal('view');
                break;
            case 'edit':
                if(!this.isModificationAllowed()){ break; }
                if(checkedFile.extension === "wopitest" || checkedFile.extension === "wopitestx"){
                    this.onOfficeFileModal('edit');
                }else{
                    this.editOfficeDoc(checkedFile);
                }
                break;
            case 'imagePreview':
                if(checkedFile !== null && !this.canPreviewFile(checkedFile)){ break; }
                this.onImagePreviewModal(true);
                break;
            case 'pdfPreview':
                if(checkedFile !== null && !this.canPreviewFile(checkedFile)){ break; }
                this.onPdfFileModal(true);
                break;
            case 'note':
                this.onNoteModal(true);
                break;
            case 'pdfActivity':
                this.history.push("/user/pdf/analytics/"+data.id);
                break;
            case 'pdfTracking':
                this.onPdfTrackingModal(true);
                break;
            default:
                break;
        }
    }
    onPdfFileModal(status = false){
        let state = {};
        state['pdfFileModal'] = status;
        if(status === false){
            state['checked'] = [];
            state['downloadFile'] = false;
            state['file'] = null;
        }
        this.setState(state)
    }
    onNoPreviewModal(status = false){
        let state = {};
        state['noPreviewModal'] = status;
        if(status === false){
            state['checked'] = [];
            state['downloadFile'] = false;
            state['file'] = null;
        }
        this.setState(state)
    }
    onImagePreviewModal(status = false){
        let state = {};
        state['imagePreviewModal'] = status;
        if(status === false){
            state['checked'] = [];
            state['downloadFile'] = false;
            state['file'] = null;
        }
        this.setState(state)
    }
    editOfficeDoc(file, newFile = false){
        let expiresAt = Cookie.read("expires_at");
        if(!expiresAt || expiresAt === "null"){
            expiresAt = 0;
        }
        // const url = Config.getWopiApiUrl()+"document/edit/"+checkedFile.id;
        let url = window.location.origin+"/document/edit/"+file.id;
        if(newFile){
            url = window.location.origin+"/document/editnew/"+file.id;
        }
        // this.editDocTokenRef.current.value = Cookie.read("oauth_token")+":"+Cookie.read("oauth_secret");
        this.editDocRef.current.setAttribute("action", url);
        this.editDocRef.current.submit();
        // this.editDocTokenRef.current.value = '';
    }
    onOfficeFileModal(action, status = true){
        this.setState({
            officeFileModal: status,
            officeFileAction: action
        });
    }
    handleLeftMenuClick(e, file){
        const x = e.clientX;
        const y = e.clientY;
        showMenu({
            position: { x, y },
            id: "file_dropdown_menu",
            data: file
        });
    }
    onContextMenuShow(e){
        const { checked, path } = this.state;
        if(checked.length > 1){
            return;
        }
        const file = e.detail.data;
        let state = {};
        state['currentFile'] = (file ? file : null);
        if(path === "/"){
            state['sharedWith'] = (file ? file.sharedWith : null);
            state['ownerId'] = (file ? file.owner_id : null);
        }
        this.setState(state, () => {
            this.handleToggle(file, true);
        });
    }
    getCheckedFiles(){
        const { response, checked } = this.state;
        if(checked.length <= 0){
            return [];
        }
        let files = [];
        response.map((file) => {
            if(checked.indexOf(file.id) !== -1){
                files.push(file);
            }
            return null;
        });
        return files;
    }
    onCopyModal(modal = true){
        this.setState({
            copyFilesModal: modal,
            errorMessage: null
        });
    }
    onCopyModalSuccess(newPath){
        const source = axios.CancelToken.source();
        this.setState({
            copyingFilesModal: true,
            cancelToken: source,
        });
        const { checked, fileId } = this.state;
        const requestData = {
            path: newPath,
            files: checked
        };
        if(fileId !== null){
            requestData['sharedFileId'] = fileId;
        }
        Api.copyFiles(requestData, source).then(data => {
            this.loadFiles();
        }).catch(err => {
            if(err.error === true){
                this.setState({
                    errorMessage: err.message,
                    copyingFilesModal: false,
                    cancelToken: null
                });
            }
            console.log(err);
        });
    }
    onMoveModal(modal = true){
        this.setState({
            moveFilesModal: modal,
            errorMessage: null
        });
    }
    onMoveModalSuccess(newPath){
        const source = axios.CancelToken.source();
        this.setState({
            movingFilesModal: true,
            cancelToken: source,
        });
        const { checked, fileId } = this.state;
        const requestData = {
            path: newPath,
            files: checked
        };
        if(fileId !== null){
            requestData['sharedFileId'] = fileId;
        }
        Api.moveFiles(requestData, source).then(data => {
            this.loadFiles();
        }).catch(err => {
            if(err.error === true){
                this.setState({
                    errorMessage: err.message,
                    movingFilesModal: false,
                    cancelToken: null
                });
            }
            console.log(err);
        });
    }
    onRenameModal(modal = true){
        this.setState({
            renameFileModal: modal,
            errorMessage: null
        });
    }
    onRenameModalSuccess(newFileName){
        const checkedFile = this.getCheckedFile();
        if(checkedFile === null){
            return;
        }
        const source = axios.CancelToken.source();
        this.setState({
            renamingFileModal: true,
            cancelToken: source,
        });
        const requestData = {
            name: newFileName,
        };
        const { fileId } = this.state;
        if(fileId !== null){
            requestData['sharedFileId'] = fileId;
        }
        Api.renameFile(checkedFile.id, requestData, source).then(data => {
            this.loadFiles();
        }).catch(err => {
            if(err && err.duplicate === true){
                this.setState({cancelToken: null, errorMessage: err.message, renamingFileModal: false});
            }
            console.log(err);
        });
    }
    getCheckedFile(checked = null){
        const { response } = this.state;
        if(checked === null){
            checked = this.state.checked;
        }
        if(checked.length <= 0){
            return null;
        }
        let currentFile = null;
        response.map((file) => {
            if(currentFile !== null){
                return null;
            }
            if(checked.indexOf(file.id) !== -1){
                currentFile = file;
            }
            return null;
        });
        return currentFile;
    }
    onDrop(filesArray){
        this.setState({
            files: filesArray,
            uploadFileModal: true
        });
    }
    isOwnerUser(){
        const { ownerId } = this.state;
        const { user } = this.store.getState();
        return ownerId !== null && ownerId === user.id;
    }
    // Manage = delete / copy / move / rename / share (full access or owner only).
    isModificationAllowed(){
        const { rootPrivacy, path } = this.state;
        if(path === '/'){
            return false;
        }
        return helper.canManageSharedFiles(rootPrivacy, this.isOwnerUser());
    }
    // Upload / create into the current shared folder.
    isUploadAllowed(){
        const { rootPrivacy, path } = this.state;
        if(path === '/'){
            return false;
        }
        return helper.canUploadSharedFiles(rootPrivacy, this.isOwnerUser());
    }
    // Download the current selection.
    isDownloadAllowed(){
        const { rootPrivacy, fileId } = this.state;
        const { user } = this.store.getState();
        const isOwner = this.isOwnerUser();
        if(isOwner){
            return true;
        }
        const files = this.getCheckedFiles();
        if(files.length > 0){
            let allowed = true;
            files.map((f) => {
                // A user may always download files they uploaded themselves
                // (e.g. an Upload-permission user retrieving their own upload).
                const ownsFile = (f.owner_id !== undefined && f.owner_id !== null && f.owner_id === user.id);
                const p = (f.privacy !== undefined && f.privacy !== null && f.privacy !== "") ? f.privacy : rootPrivacy;
                if(!ownsFile && !helper.canDownloadSharedFiles(p, isOwner)){
                    allowed = false;
                }
                return null;
            });
            return allowed;
        }
        if(fileId !== null){
            return helper.canDownloadSharedFiles(rootPrivacy, isOwner);
        }
        return false;
    }
    // Preview/open a specific file.
    canPreviewFile(file){
        const { rootPrivacy } = this.state;
        const p = (file && file.privacy !== undefined && file.privacy !== null && file.privacy !== "") ? file.privacy : rootPrivacy;
        return helper.canPreviewSharedFiles(p, this.isOwnerUser());
    }
    onRelatedLinks(){
        const { checked } = this.state;
        if(checked.length <= 0){
            return;
        }

        const url = "/user/links?page=1&files="+checked.join(",");
        this.history.push(url);
    }
    onNewDocMenuSuccess(extension){
        this.setState({
            docMenuEl: null,
            newFileModal: true,
            newFileExtension: extension
        });
    }
    onNewFileModal(status = false){
        this.setState({
            docMenuEl: null,
            newFileModal: status,
            newFileExtension: null,
            uploadMenuEl: null,
        });
    }
    onNewFileModalSuccess(fileName){
        const { newFileExtension, fileId } = this.state;
        const source = axios.CancelToken.source();
        this.setState({
            creatingFile: true,
            cancelToken: source,
        });

        const requestData = {
            fileName: (fileName+"."+newFileExtension),
            path: this.state.path
        };
        if(fileId !== null){
            requestData['sharedFileId'] = fileId;
        }
        Api.addNewFile(requestData, source).then(data => {
            this.editOfficeDoc(data, true);
            this.setState({
                docMenuEl: null,
                newFileModal: false,
                newFileExtension: null,
                creatingFile: false,
                newFileError: false,
                newFileErrorMessage: null
            }, () => {
                this.loadFiles();
            });
        }).catch(err => {
            console.log(err);
        });
    }
    updateLoginStatus(){
        const values = {}
        const source = axios.CancelToken.source();
        Api.updateLoginStatus(values, source).then((data) => {
            let newUser = Api.prepareMemberObject(data.user);
            localStorage.setItem("show_first_view_shared", false);
            this.setState({
                newUser: newUser
            })
        }).catch(err => {
            this.setState({
                savingInfo: false, 
                showError: true, 
                errorMessage: err.message
            });
        });
    }
    onUploadMenu(event){
        this.setState({
            uploadMenuEl: event.currentTarget
        });
    }
    renderUploadMenu(){
        const { uploadMenuEl } = this.state;
        const { classes } = this.props;
        return (
            <Menu
                id="upload-menu"
                anchorEl={uploadMenuEl}
                keepMounted
                open={Boolean(uploadMenuEl)}
                onClose={() => this.onNewFileModal()}
                className={classes.createMenu}
                PaperProps={{
                    style: {
                      marginTop: '80px',
                    },
                }}
            >
                <MuiMenuItem onClick={() => this.onUploadModal(true, 'file')} className='folder-menu'>
                    <Button justIcon color="transparent" className={classes.fileIcon}>
                        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_1017_4426)">
                            <path opacity="0.4" d="M0 2.25C0 1.00898 1.00898 0 2.25 0H7.875V4.5C7.875 5.12227 8.37773 5.625 9 5.625H13.5V15.75C13.5 16.991 12.491 18 11.25 18H2.25C1.00898 18 0 16.991 0 15.75V2.25ZM3.375 10.6875C3.375 10.902 3.45586 11.1199 3.62109 11.2852C3.95156 11.6156 4.48594 11.6156 4.81289 11.2852L5.90273 10.1953L5.90625 13.7812C5.90625 14.2488 6.28242 14.625 6.75 14.625C7.21758 14.625 7.59375 14.2488 7.59375 13.7812V10.1918L8.68359 11.2816C9.01406 11.6121 9.54844 11.6121 9.87539 11.2816C10.2023 10.9512 10.2059 10.4168 9.87539 10.0898L7.34414 7.55859C7.01367 7.22813 6.4793 7.22813 6.15234 7.55859L3.62109 10.0898C3.45586 10.2551 3.375 10.4695 3.375 10.6875Z" fill="#556DC2"/>
                            <path d="M13.4999 5.625H8.99986C8.37759 5.625 7.87486 5.12227 7.87486 4.5V0L13.4999 5.625ZM7.59361 13.7812C7.59361 14.2488 7.21743 14.625 6.74986 14.625C6.28228 14.625 5.90611 14.2488 5.90611 13.7812V10.1918L4.81626 11.2816C4.48579 11.6121 3.95142 11.6121 3.62446 11.2816C3.29751 10.9512 3.294 10.4168 3.62446 10.0898L6.15571 7.55859C6.48618 7.22813 7.02056 7.22813 7.34751 7.55859L9.87876 10.0898C10.2092 10.4203 10.2092 10.9547 9.87876 11.2816C9.54829 11.6086 9.01392 11.6121 8.68696 11.2816L7.59712 10.1918L7.59361 13.7812Z" fill="#556DC2"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_1017_4426">
                            <rect width="13.5" height="18" fill="white"/>
                            </clipPath>
                            </defs>
                        </svg>
                    </Button>
                    Upload File
                </MuiMenuItem>
                <MuiMenuItem onClick={() => this.onUploadModal(true, 'folder')} className='folder-menu'>
                    <Button justIcon color="transparent" className={classes.fileIcon}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.4" d="M0 3.375V14.625C0 15.866 1.00898 16.875 2.25 16.875H15.75C16.991 16.875 18 15.866 18 14.625V5.625C18 4.38398 16.991 3.375 15.75 3.375H10.125C9.76992 3.375 9.43594 3.20977 9.225 2.925L8.55 2.025C8.12461 1.45898 7.45664 1.125 6.75 1.125H2.25C1.00898 1.125 0 2.13398 0 3.375ZM5.625 9.5625C5.625 9.34805 5.70586 9.13008 5.87109 8.96484L8.40234 6.43359C8.56758 6.26836 8.78203 6.1875 9 6.1875C9.21797 6.1875 9.43242 6.26836 9.59766 6.43359L12.1289 8.96484C12.2941 9.13008 12.375 9.34453 12.375 9.5625C12.375 9.78047 12.2941 9.99492 12.1289 10.1602C11.7984 10.4906 11.2641 10.4906 10.9371 10.1602L9.84727 9.07031L9.84375 12.6562C9.84375 13.1238 9.46758 13.5 9 13.5C8.53242 13.5 8.15625 13.1238 8.15625 12.6562V9.0668L7.06641 10.1566C6.73594 10.4871 6.20156 10.4871 5.87461 10.1566C5.70937 9.99141 5.62852 9.77695 5.62852 9.55898L5.625 9.5625Z" fill="#FAAF42"/>
                            <path d="M8.9998 13.5C9.46738 13.5 9.84355 13.1239 9.84355 12.6563V9.06685L10.9334 10.1567C11.2639 10.4872 11.7982 10.4872 12.1252 10.1567C12.4521 9.82622 12.4557 9.29185 12.1252 8.96489L9.59395 6.43364C9.26348 6.10317 8.7291 6.10317 8.40215 6.43364L5.8709 8.96489C5.54043 9.29536 5.54043 9.82974 5.8709 10.1567C6.20137 10.4836 6.73574 10.4872 7.0627 10.1567L8.15254 9.06685L8.15605 12.6563C8.15605 13.1239 8.53223 13.5 8.9998 13.5Z" fill="#FAAF42"/>
                        </svg>
                    </Button>
                    Upload Folder
                </MuiMenuItem>
            </Menu>
        )
    }
    renderCreateMenu(){
        const { docMenuEl } = this.state;
        const { classes } = this.props;
        const { user } = this.store.getState();

        return (
            <Menu
                id="new-doc-menu"
                anchorEl={docMenuEl}
                keepMounted
                open={Boolean(docMenuEl)}
                onClose={() => this.onNewFileModal()}
                className={classes.createMenu}
                PaperProps={{
                    style: {
                      marginTop: '80px',
                    },
                }}
            >
                <MuiMenuItem onClick={() => this.onNewFolderModal(true)} className='folder-menu'>
                    <Button justIcon color="transparent" className={classes.fileIcon}>
                        { helper.getFolderIcon() }
                    </Button>
                    New Folder
                </MuiMenuItem>
                {
                    helper.isExtensionAllowed(user, 'ms_office') && helper.isExtensionEnable(user, 'ms_office') ?
                        <>
                            <MuiMenuItem onClick={() => this.onNewDocMenuSuccess("docx")} className='word-menu'>
                                {helper.getFileIcon({extension: "docx"}, classes)}
                                Word Document
                            </MuiMenuItem>
                            <MuiMenuItem onClick={() => this.onNewDocMenuSuccess("xlsx")} className='excel-menu'>
                                {helper.getFileIcon({extension: "xlsx"}, classes)}
                                Excel Workbook
                            </MuiMenuItem>
                            <MuiMenuItem onClick={() => this.onNewDocMenuSuccess("pptx")} className='powerpoint-menu'>
                                {helper.getFileIcon({extension: "pptx"}, classes)}
                                Powerpoint Presentation
                            </MuiMenuItem>
                        </>
                    :
                        <></>
                }
            </Menu>
        )
    }
    onNewOfficeDoc(event){
        this.setState({
            docMenuEl: event.currentTarget
        });
    }
    onFileActionMenu(event, status = true){
        let target = null;
        if(status){
            target = event.currentTarget
        }
        this.setState({
            fileActionsMenuEl: target
        })
    }
    renderFileActionsMenu(){
        const { fileActionsMenuEl } = this.state;
        const { classes } = this.props;
        return (
            <Menu
                id="new-doc-menu"
                anchorEl={fileActionsMenuEl}
                keepMounted
                open={Boolean(fileActionsMenuEl)}
                onClose={(e) => this.onFileActionMenu(e, false)}
                className={classes.fileActionsDropdown}
                PaperProps={{
                    style: {
                      marginTop: '45px',
                    },
                }}
            >
                {
                    this.isModificationAllowed() ?
                        <MuiMenuItem onClick={() => this.deleteSelected()} className='folder-menu'>
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.74308 1.125H10.2531C10.4618 1.125 10.6554 1.22344 10.7692 1.38867L11.3498 2.25H5.65022L6.2308 1.38867C6.34085 1.22344 6.53817 1.125 6.74688 1.125H6.74308ZM12.7842 2.25L11.8013 0.794531C11.4674 0.298828 10.883 0 10.2569 0H6.74308C6.11696 0 5.53259 0.298828 5.19866 0.794531L4.21585 2.25H2.43237H1.21429H0.607143C0.273214 2.25 0 2.50312 0 2.8125C0 3.12188 0.273214 3.375 0.607143 3.375H1.30156L2.2692 15.9117C2.35647 17.0895 3.41518 18 4.69018 18H12.3098C13.5848 18 14.6397 17.0895 14.7308 15.9117L15.6984 3.375H16.3929C16.7268 3.375 17 3.12188 17 2.8125C17 2.50312 16.7268 2.25 16.3929 2.25H15.7857H14.5676H12.7842ZM14.4842 3.375L13.5203 15.8309C13.4748 16.418 12.9473 16.875 12.3098 16.875H4.69018C4.05268 16.875 3.52522 16.418 3.47969 15.8309L2.51964 3.375H14.4804H14.4842Z"/>
                            </svg>
                            Delete
                        </MuiMenuItem>
                    :
                        <></>
                }
                {
                    this.isDownloadAllowed() ?
                        <MuiMenuItem onClick={() => this.onDownloadModal()} className='folder-menu'>
                            <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7723 7.70977L8.27227 12.2098C8.0543 12.4277 7.6957 12.4277 7.47773 12.2098L2.97773 7.70977C2.75977 7.4918 2.75977 7.1332 2.97773 6.91523C3.1957 6.69727 3.5543 6.69727 3.77227 6.91523L7.3125 10.4555V0.5625C7.3125 0.253125 7.56563 0 7.875 0C8.18437 0 8.4375 0.253125 8.4375 0.5625V10.4555L11.9777 6.91523C12.1957 6.69727 12.5543 6.69727 12.7723 6.91523C12.9902 7.1332 12.9902 7.4918 12.7723 7.70977ZM1.125 11.8125V15.1875C1.125 16.1191 1.88086 16.875 2.8125 16.875H12.9375C13.8691 16.875 14.625 16.1191 14.625 15.1875V11.8125C14.625 11.5031 14.8781 11.25 15.1875 11.25C15.4969 11.25 15.75 11.5031 15.75 11.8125V15.1875C15.75 16.7414 14.4914 18 12.9375 18H2.8125C1.25859 18 0 16.7414 0 15.1875V11.8125C0 11.5031 0.253125 11.25 0.5625 11.25C0.871875 11.25 1.125 11.5031 1.125 11.8125Z"/>
                            </svg>
                            Download
                        </MuiMenuItem>
                    :
                        <></>
                }
            </Menu>
        )
    }
    isRelatedLinkEnable(){
        const { checked, response } = this.state;
        if(checked.length <= 0){
            return false;
        }

        let haveRelatedLink = false;
        response.map(file => {
            if(checked.includes(file.id)){
                if(file.relatedLinks.length > 0){
                    haveRelatedLink = true;
                }
            }
            return null;
        })
        
        return haveRelatedLink;
    }
    getFilesContent(files){
        const { classes } = this.props;
        const { loading, loadingMore, page, totalPages, fileId, checked, filter, searchFormData, backPath } = this.state;
        const breadcrumbs = this.getBreadCrumbs();
        const tableData = this.getTableData();
        const modificationAllowed = this.isModificationAllowed();
        const uploadAllowed = this.isUploadAllowed();
        const downloadAllowed = this.isDownloadAllowed();
        const { user } = this.store.getState();

        let content = (
            <div className={classes.content+" "+classes.flexPageContent}>
                <div className={classes.controls}>
                    <GridItem className={classes.controlsTabs}>
                        <h4>Shared</h4>
                        <GridContainer className={classes.alignItems}>
                            <GridItem xs={12} sm={12} md={8}>
                                <div className='sd-custom-tabs'>
                                    <div className={'sd-custom-tab '+(filter === "all" ? 'active': '')} onClick={() => this.loadFiles(false, null, "/", null, "all")}>
                                        <span>All</span>
                                    </div>
                                    <div className={'sd-custom-tab '+(filter === "you" ? 'active': '')} onClick={() => this.loadFiles(false, null, "/", null, "you")}>
                                        <span>With You</span>
                                    </div>
                                    <div className={'sd-custom-tab '+(filter === "others" ? 'active': '')} onClick={() => this.loadFiles(false, null, "/", null, "others")}>
                                        <span>With Others</span>
                                    </div>
                                </div>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                                <SearchInput 
                                    searchFormData={searchFormData} 
                                    onSuccess={(searchData) => this.onSearchInputSuccess(searchData)} 
                                    clearSearch={() => this.clearSearch()} 
                                    history={this.history} 
                                    store={this.store} 
                                    inputProps={{
                                        placeholder: "Search Files & Folders"
                                    }}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem>
                        <div className={classes.controlButtons+" "+(user.theme === 'standard' ? '': 'light-theme-buttons')}>
                            {
                                uploadAllowed ?
                                    <>
                                        <Button color="transparent" title="Upload" aria-controls="upload-menu" aria-haspopup="true" onClick={(event) => this.onUploadMenu(event)}>
                                            <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.5549 0.238696C11.2504 -0.0761475 10.7496 -0.0761475 10.4451 0.238696L4.15937 6.7387C3.85491 7.05354 3.85491 7.57151 4.15937 7.88635C4.46384 8.2012 4.96473 8.2012 5.2692 7.88635L10.2143 2.77268V17.0625C10.2143 17.5094 10.5679 17.875 11 17.875C11.4321 17.875 11.7857 17.5094 11.7857 17.0625V2.77268L16.7308 7.88635C17.0353 8.2012 17.5362 8.2012 17.8406 7.88635C18.1451 7.57151 18.1451 7.05354 17.8406 6.7387L11.5549 0.238696ZM1.57143 17.0625C1.57143 16.6157 1.21786 16.25 0.785714 16.25C0.353571 16.25 0 16.6157 0 17.0625V21.9375C0 24.1821 1.75804 26 3.92857 26H18.0714C20.242 26 22 24.1821 22 21.9375V17.0625C22 16.6157 21.6464 16.25 21.2143 16.25C20.7821 16.25 20.4286 16.6157 20.4286 17.0625V21.9375C20.4286 23.2832 19.3728 24.375 18.0714 24.375H3.92857C2.62723 24.375 1.57143 23.2832 1.57143 21.9375V17.0625Z"/>
                                            </svg>
                                            Upload
                                        </Button>
                                        {this.renderUploadMenu()}
                                        <Button color="transparent" title="Create" aria-controls="new-doc-menu" aria-haspopup="true" onClick={(event) => this.onNewOfficeDoc(event)}>
                                            <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.7858 3.125C11.7858 2.69531 11.4322 2.34375 11.0001 2.34375C10.5679 2.34375 10.2143 2.69531 10.2143 3.125V11.7188H1.57148C1.13934 11.7188 0.785767 12.0703 0.785767 12.5C0.785767 12.9297 1.13934 13.2812 1.57148 13.2812H10.2143V21.875C10.2143 22.3047 10.5679 22.6562 11.0001 22.6562C11.4322 22.6562 11.7858 22.3047 11.7858 21.875V13.2812H20.4286C20.8608 13.2812 21.2143 12.9297 21.2143 12.5C21.2143 12.0703 20.8608 11.7188 20.4286 11.7188H11.7858V3.125Z"/>
                                            </svg>
                                            Create
                                        </Button>
                                        {this.renderCreateMenu()}
                                    </>
                                :
                                    <></>
                            }
                        </div>
                    </GridItem>
                </div>
                <GridItem className={classes.breadcrumbsActionsLayouts}>
                    <div className={classes.breadcrumbs}>
                    {
                            loading === false && breadcrumbs.length > 0 ?
                                <>
                                    {
                                        breadcrumbs.map((breadCrumb, key) => {
                                            return (
                                                <div key={key}>
                                                    {
                                                        key !== 0 ?
                                                            <span><ChevronRight /></span>
                                                        :
                                                            <></>
                                                    }
                                                    <Link href="/user/shared" onClick={(e) => {e.preventDefault(); this.loadFiles(false, null, breadCrumb.value);}}>
                                                        {breadCrumb.label}
                                                    </Link>
                                                </div>
                                            )
                                        })
                                    }
                                </>
                            :
                                <></>
                        }
                    </div>
                    <div className={"file-actions-layouts"}>
                        {
                            checked.length > 0 ?
                                <div className={classes.fileActionsMenu}>
                                    {
                                        user.level_id !== 5 && this.isRelatedLinkEnable() ?
                                            <Button className={"related-link-button"} color="transparent" onClick={() => this.onRelatedLinks()} title="Related Links">
                                                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clipPath="url(#clip0_470_28)">
                                                        <path d="M0 3.5C0 2.67266 0.672656 2 1.5 2H5.25V5C5.25 5.41484 5.58516 5.75 6 5.75H9V12.5C9 13.3273 8.32734 14 7.5 14H1.5C0.672656 14 0 13.3273 0 12.5V3.5ZM9 5H6V2L9 5Z" fill="#556DC2"/>
                                                    </g>
                                                    <path d="M18 2.86008C18 4.43829 16.7153 5.71658 15.1292 5.71658C14.3074 5.71658 13.5645 5.3738 13.0442 4.82392L7.62547 7.51975C7.65418 7.67686 7.66494 7.83754 7.66494 8.00179C7.66494 8.16603 7.65059 8.32671 7.62547 8.48382L13.0442 11.1796C13.5681 10.6298 14.3074 10.287 15.1292 10.287C16.7153 10.287 18 11.5653 18 13.1435C18 14.7217 16.7153 16 15.1292 16C13.543 16 12.2583 14.7217 12.2583 13.1435C12.2583 12.7971 12.3193 12.4651 12.4341 12.1544L7.8462 9.69126C7.00015 9.55501 8.26927 9.69126 7.00015 9.55501C7.00005 10.4861 7.00015 10.3216 7.00015 8.74339C7.00015 7.16517 6.9999 8.74339 7.00004 7.94854C7.00004 6.75626 6.99699 6.60634 7.62552 6.40537L12.4341 3.84557C12.3193 3.5385 12.2583 3.20643 12.2583 2.85651C12.2583 1.27829 13.543 0 15.1292 0C16.7153 0 18 1.27829 18 2.85651V2.86008ZM16.8517 2.86008C16.8517 2.40552 16.6702 1.96958 16.3471 1.64816C16.0241 1.32674 15.586 1.14617 15.1292 1.14617C14.6723 1.14617 14.2342 1.32674 13.9112 1.64816C13.5881 1.96958 13.4066 2.40552 13.4066 2.86008C13.4066 3.31463 13.5881 3.75057 13.9112 4.07199C14.2342 4.39341 14.6723 4.57398 15.1292 4.57398C15.586 4.57398 16.0241 4.39341 16.3471 4.07199C16.6702 3.75057 16.8517 3.31463 16.8517 2.86008ZM15.1292 14.8574C15.3554 14.8574 15.5793 14.8131 15.7883 14.7269C15.9973 14.6408 16.1872 14.5146 16.3471 14.3554C16.5071 14.1963 16.634 14.0073 16.7205 13.7994C16.8071 13.5914 16.8517 13.3686 16.8517 13.1435C16.8517 12.9184 16.8071 12.6956 16.7205 12.4876C16.634 12.2797 16.5071 12.0907 16.3471 11.9316C16.1872 11.7724 15.9973 11.6462 15.7883 11.5601C15.5793 11.4739 15.3554 11.4296 15.1292 11.4296C14.9029 11.4296 14.679 11.4739 14.47 11.5601C14.261 11.6462 14.0711 11.7724 13.9112 11.9316C13.7512 12.0907 13.6243 12.2797 13.5378 12.4876C13.4512 12.6956 13.4066 12.9184 13.4066 13.1435C13.4066 13.3686 13.4512 13.5914 13.5378 13.7994C13.6243 14.0073 13.7512 14.1963 13.9112 14.3554C14.0711 14.5146 14.261 14.6408 14.47 14.7269C14.679 14.8131 14.9029 14.8574 15.1292 14.8574Z" fill="#556DC2"/>
                                                    <defs>
                                                        <clipPath id="clip0_470_28">
                                                            <rect width="9" height="12" fill="white" transform="translate(0 2)"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                Related Links
                                            </Button>
                                        :
                                            <></>
                                    }
                                    {
                                        modificationAllowed ?
                                            <Button className={"delete-button"} color="transparent" disabled={checked.length <= 0 ? true : false} onClick={() => this.deleteSelected()} title="Delete">
                                                <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.74308 1.125H10.2531C10.4618 1.125 10.6554 1.22344 10.7692 1.38867L11.3498 2.25H5.65022L6.2308 1.38867C6.34085 1.22344 6.53817 1.125 6.74688 1.125H6.74308ZM12.7842 2.25L11.8013 0.794531C11.4674 0.298828 10.883 0 10.2569 0H6.74308C6.11696 0 5.53259 0.298828 5.19866 0.794531L4.21585 2.25H2.43237H1.21429H0.607143C0.273214 2.25 0 2.50312 0 2.8125C0 3.12188 0.273214 3.375 0.607143 3.375H1.30156L2.2692 15.9117C2.35647 17.0895 3.41518 18 4.69018 18H12.3098C13.5848 18 14.6397 17.0895 14.7308 15.9117L15.6984 3.375H16.3929C16.7268 3.375 17 3.12188 17 2.8125C17 2.50312 16.7268 2.25 16.3929 2.25H15.7857H14.5676H12.7842ZM14.4842 3.375L13.5203 15.8309C13.4748 16.418 12.9473 16.875 12.3098 16.875H4.69018C4.05268 16.875 3.52522 16.418 3.47969 15.8309L2.51964 3.375H14.4804H14.4842Z" fill="#556DC2"/>
                                                </svg>
                                                Delete
                                            </Button>
                                        :
                                            <></>
                                    }
                                    {
                                        (fileId !== null || checked.length === 1) && downloadAllowed ?
                                            <Button className={"download-button"} color="transparent" disabled={checked.length <= 0 ? true : false} onClick={() => this.onDownloadModal(true)} title="Download">
                                                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.7723 7.70977L8.27227 12.2098C8.0543 12.4277 7.6957 12.4277 7.47773 12.2098L2.97773 7.70977C2.75977 7.4918 2.75977 7.1332 2.97773 6.91523C3.1957 6.69727 3.5543 6.69727 3.77227 6.91523L7.3125 10.4555V0.5625C7.3125 0.253125 7.56563 0 7.875 0C8.18437 0 8.4375 0.253125 8.4375 0.5625V10.4555L11.9777 6.91523C12.1957 6.69727 12.5543 6.69727 12.7723 6.91523C12.9902 7.1332 12.9902 7.4918 12.7723 7.70977ZM1.125 11.8125V15.1875C1.125 16.1191 1.88086 16.875 2.8125 16.875H12.9375C13.8691 16.875 14.625 16.1191 14.625 15.1875V11.8125C14.625 11.5031 14.8781 11.25 15.1875 11.25C15.4969 11.25 15.75 11.5031 15.75 11.8125V15.1875C15.75 16.7414 14.4914 18 12.9375 18H2.8125C1.25859 18 0 16.7414 0 15.1875V11.8125C0 11.5031 0.253125 11.25 0.5625 11.25C0.871875 11.25 1.125 11.5031 1.125 11.8125Z" fill="#556DC2"/>
                                                </svg>
                                                Download
                                            </Button>  
                                        :
                                            <></>
                                    }
                                    {
                                        (fileId !== null || checked.length === 1) && modificationAllowed ?
                                            <>
                                                {
                                                    user.level_id !== 5 ?
                                                        <Button className={"newlink-button"} color="transparent" disabled={checked.length <= 0 ? true : false} onClick={() => this.onShareModal(true)} title="New Link">
                                                            <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M21.3393 10.1999C22.8866 8.64384 22.8866 6.12301 21.3393 4.56695C19.7919 3.01089 17.2853 3.01089 15.7379 4.56695L15.0385 5.27029C14.8467 5.46324 14.8467 5.78068 15.0385 5.97363C15.2304 6.16658 15.5461 6.16658 15.7379 5.97363L16.4373 5.27029C17.5978 4.10324 19.4794 4.10324 20.6399 5.27029C21.8004 6.43734 21.8004 8.32951 20.6399 9.49656L16.7839 13.3712C15.6265 14.5351 13.7481 14.5351 12.5876 13.3712C11.4859 12.2632 11.424 10.4893 12.4421 9.30672L12.6061 9.11688C12.7856 8.90837 12.764 8.59404 12.5566 8.41354C12.3493 8.23304 12.0367 8.25482 11.8572 8.46334L11.6932 8.65317C10.3346 10.231 10.4182 12.5962 11.8851 14.0714C13.4293 15.6243 15.936 15.6243 17.4802 14.0714L21.3393 10.1999ZM4.53525 10.1999C2.98792 11.756 2.98792 14.2768 4.53525 15.8329C6.08258 17.3889 8.58926 17.3889 10.1366 15.8329L10.836 15.1295C11.0279 14.9366 11.0279 14.6191 10.836 14.4262C10.6441 14.2332 10.3285 14.2332 10.1366 14.4262L9.43719 15.1295C8.2767 16.2966 6.39514 16.2966 5.23465 15.1295C4.07415 13.9625 4.07415 12.0703 5.23465 10.9032L9.09059 7.02864C10.248 5.86471 12.1265 5.86471 13.287 7.02864C14.3887 8.13656 14.4505 9.91048 13.4324 11.0931L13.2684 11.2829C13.0889 11.4914 13.1106 11.8058 13.3179 11.9863C13.5252 12.1668 13.8378 12.145 14.0173 11.9365L14.1813 11.7466C15.5399 10.1688 15.4563 7.80356 13.9894 6.32842C12.439 4.76924 9.93544 4.76924 8.38811 6.32219L4.53525 10.1999Z"/>
                                                                <path d="M4.37019 2.70262C4.37019 2.46152 4.17683 2.26672 3.9375 2.26672C3.69817 2.26672 3.50481 2.46152 3.50481 2.70262V4.66416H1.55769C1.31836 4.66416 1.125 4.85895 1.125 5.10006C1.125 5.34116 1.31836 5.53595 1.55769 5.53595H3.50481V7.49749C3.50481 7.7386 3.69817 7.93339 3.9375 7.93339C4.17683 7.93339 4.37019 7.7386 4.37019 7.49749V5.53595H6.31731C6.55664 5.53595 6.75 5.34116 6.75 5.10006C6.75 4.85895 6.55664 4.66416 6.31731 4.66416H4.37019V2.70262Z"/>
                                                            </svg>
                                                            New Link
                                                        </Button>
                                                    :
                                                        <></>
                                                }
                                            </>
                                        :
                                            <></>
                                    }
                                    {
                                        (this.isModificationAllowed() || this.isDownloadAllowed()) ?
                                            <>
                                                <Button className={"more-button"} color="transparent" disabled={checked.length <= 0 ? true : false} aria-controls="new-doc-menu" aria-haspopup="true" onClick={(event) => this.onFileActionMenu(event)}>
                                                    <svg width="20" height="5" viewBox="0 0 20 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M19.4062 2.5C19.4062 3.07187 19.1791 3.62032 18.7747 4.0247C18.3703 4.42907 17.8219 4.65625 17.25 4.65625C16.6781 4.65625 16.1297 4.42907 15.7253 4.0247C15.3209 3.62032 15.0938 3.07187 15.0938 2.5C15.0938 1.92813 15.3209 1.37968 15.7253 0.975301C16.1297 0.570925 16.6781 0.34375 17.25 0.34375C17.8219 0.34375 18.3703 0.570925 18.7747 0.975301C19.1791 1.37968 19.4062 1.92813 19.4062 2.5ZM12.2188 2.5C12.2188 2.78316 12.163 3.06355 12.0546 3.32516C11.9463 3.58677 11.7874 3.82447 11.5872 4.0247C11.387 4.22493 11.1493 4.38375 10.8877 4.49212C10.6261 4.60048 10.3457 4.65625 10.0625 4.65625C9.77934 4.65625 9.49895 4.60048 9.23734 4.49212C8.97573 4.38375 8.73803 4.22493 8.5378 4.0247C8.33757 3.82447 8.17875 3.58677 8.07038 3.32516C7.96202 3.06355 7.90625 2.78316 7.90625 2.5C7.90625 2.21684 7.96202 1.93645 8.07038 1.67484C8.17875 1.41323 8.33757 1.17553 8.5378 0.975301C8.73803 0.775074 8.97573 0.616246 9.23734 0.507885C9.49895 0.399523 9.77934 0.34375 10.0625 0.34375C10.3457 0.34375 10.6261 0.399523 10.8877 0.507885C11.1493 0.616246 11.387 0.775074 11.5872 0.975301C11.7874 1.17553 11.9463 1.41323 12.0546 1.67484C12.163 1.93645 12.2188 2.21684 12.2188 2.5ZM2.875 4.65625C2.30313 4.65625 1.75468 4.42907 1.3503 4.0247C0.945926 3.62032 0.71875 3.07187 0.71875 2.5C0.71875 1.92813 0.945926 1.37968 1.3503 0.975301C1.75468 0.570925 2.30313 0.34375 2.875 0.34375C3.44687 0.34375 3.99532 0.570925 4.3997 0.975301C4.80407 1.37968 5.03125 1.92813 5.03125 2.5C5.03125 3.07187 4.80407 3.62032 4.3997 4.0247C3.99532 4.42907 3.44687 4.65625 2.875 4.65625Z"/>
                                                    </svg>
                                                </Button>
                                                {this.renderFileActionsMenu()}
                                            </>
                                        :
                                            <></>
                                    }
                                </div>
                            :
                                <></>
                        }
                    </div>
                </GridItem>
                <GridItem className={classes.tableGridItem}>
                    <div className={classes.filesContainer}>
                        <div className={classes.files}>
                            {
                                loading ?
                                    <LoaderComponent color="custom" align="center" />
                                :
                                    <ReactTable
                                        columns={this.getColumns()}
                                        data={tableData}
                                        pageSizeOptions={[500]}
                                        defaultPageSize={50000000000}
                                        showPaginationTop={false}
                                        minRows={0}
                                        showPaginationBottom={false}
                                        className={"-striped -highlight "+ (loading ? classes.loading : "")+" "+classes.filesTable+" "+(backPath.length > 0 ? classes.stickyRow : "")}
                                        getTrProps={(state, rowInfo) => this.getTrProps(state, rowInfo)}
                                        getTrGroupProps={(state, rowInfo) => this.getTrGroupProps(state, rowInfo)}
                                        getNoDataProps={() => this.getNoDataProps()}
                                    />
                            }
                            <div className={classes.loadMore}>
                                {
                                    tableData.length > 0 && loadingMore === false && page < totalPages ?
                                        <Button color="custom" id="contentViewMore" onClick={(e) => this.loadFiles(true)}>
                                            <RefreshIcon className={classes.icons} />View More
                                        </Button>
                                        
                                    :
                                        loadingMore === true ?
                                            <LoaderComponent color="custom" align="center" />
                                        :
                                        <></>
                                }
                            </div>
                        </div>
                    </div>
                </GridItem>
            </div>
        );

        if(uploadAllowed){
            return (
                <DragNDrop onDrop={(files) => this.onDrop(files)}>
                    { content }
                </DragNDrop>
            );
        }else{
            return (
                content
            );
        }
    }
    groupNotificationStatus(){
        const { 
            // ownerId, 
            groupNotification 
        } =  this.state;
        // const { user } = this.store.getState();

        let status = groupNotification;
        // if(ownerId === user.id){
        //     status = "optional";
        // }

        return status;
    }
    canEditDocument(){
        const modificationAllowed = this.isModificationAllowed();
        if(!modificationAllowed){
            return false;
        }
        const checkedFile = this.getCheckedFile();
        return helper.canEditDocument(checkedFile);
    }
    onNoteModal(modal = true){
        let checked = this.state.checked;
        if(modal === false){
            checked = [];
        }
        this.setState({
            noteModal: modal,
            fileNoteModal: false,
            errorMessage: null,
            checked: checked,
            checkedAll: false,
        });
    }
    onNoteModalSuccess(note){
        const checkedFile = this.getCheckedFile();
        if(checkedFile === null){
            return;
        }
        const source = axios.CancelToken.source();
        this.setState({
            noteSavingModal: true,
            cancelToken: source,
        });
        const requestData = {
            note: note,
        };
        const { fileId } = this.state;
        if(fileId !== null){
            requestData['sharedFileId'] = fileId;
        }
        Api.noteFile(checkedFile.id, requestData, source).then(data => {
            this.loadFiles();
        }).catch(err => {
            if(err && err.duplicate === true){
                this.setState({cancelToken: null, errorMessage: err.message, noteSavingModal: false});
            }
            console.log(err);
        });
    }
    onFileNoteModal(modal = true){
        let checked = this.state.checked;
        if(modal === false){
            checked = [];
        }
        this.setState({
            fileNoteModal: modal,
            errorMessage: null,
            checked: checked,
            checkedAll: false,
            noteModal: false,
        });
    }
    onPdfTrackingModal(modal = true){
        this.setState({
            pdfTrackingModal: modal,
        });
    }
    onPdfTrackingModalSuccess(){
        const checkedFile = this.getCheckedFile();
        if(checkedFile === null){
            return;
        }
        const source = axios.CancelToken.source();
        this.setState({
            pdfTrackingSavingModal: true,
            cancelToken: source,
        });
        const requestData = {
            enabled: checkedFile.pdf_tracking === 1 ? 0 : 1,
        };
        const { fileId } = this.state;
        if(fileId !== null){
            requestData['sharedFileId'] = fileId;
        }
        Api.pdfTracking(checkedFile.id, requestData, source).then(data => {
            this.loadFiles();
        }).catch(err => {
            if(err && err.duplicate === true){
                this.setState({cancelToken: null, errorMessage: err.message, pdfTrackingSavingModal: false});
            }
            console.log(err);
        });
    }
    render() {
        const { classes } = this.props;
        const { deleteFileModal, uploadFileModal, path, shareFileModal,
            downloadModal, downloadingFiles, newFolderModal, creatingFolder, copyFilesModal, copyingFilesModal,
            moveFilesModal, movingFilesModal, renameFileModal, renamingFileModal, files, errorMessage, checked, fileId,
            advShareModal, sharingFiles, ownerNotification, sharedWith,showError, newLinkUploaded, officeFileModal, officeFileAction,
            newFileModal, newFileExtension, creatingFile, newFileError, newFileErrorMessage, 
            ownerId, canTrackPdf, saving, imagePreviewModal, noPreviewModal, pdfFileModal, activitiesModal, activities, activitiesFileId,
            noteSavingModal, noteModal, fileNoteModal, currentFile, rootPrivacy, pdfTrackingModal } = this.state;
        const { authorized, user } = this.store.getState();
        if(!authorized){
            return (
                <div className={classes.main}>
                    <BackgroundSlider store={this.store} />
                    <Helmet>
                        <title>{process.env.REACT_APP_TITLE}</title>
                    </Helmet>
                </div>
            )
        }
        
        const canEdit = this.canEditDocument();
        const groupNotification = this.groupNotificationStatus()
        const checkedFiles = this.getCheckedFiles();
        const checkedFile = this.getCheckedFile();
        const modificationAllowed = this.isModificationAllowed();
        return (
            <div className={classes.main}>
                <div className={classes.container}>
                    {
                        this.getFilesContent(files)
                    }
                </div>
                <DeleteFileModal
                    deletedFiles={checkedFiles}
                    open={deleteFileModal}
                    onClose={() => this.onModalClose(false)}
                    onSuccess={() => this.onModalSuccess()}
                    loading={saving}
                    errorMessage={errorMessage}
                />
                {
                    uploadFileModal ?
                        <UploadFileModal 
                            sharedFileId={fileId} 
                            ownerNotification={ownerNotification} 
                            groupNotification={(groupNotification)} 
                            open={uploadFileModal} 
                            store={this.store} 
                            path={path} 
                            files={files} 
                            onClose={() => this.onUploadModal(false)} 
                            onSuccess={() => this.onUploadModalSuccess()}
                            sharedWith={sharedWith}
                            isShared={true}
                        />
                    :
                        <></>
                }
                {
                    advShareModal && path === '/' ?
                        <ShareModal
                            open={advShareModal}
                            onClose={() => this.onAdvShareModal(false)}
                            onSuccess={() => this.onAdvShareModal(false)}
                            files={checkedFiles}
                            store={this.store} 
                            checked={checked}
                            sharedWith={sharedWith}
                            sharedPage={true}
                        />
                    :
                    <></>
                }
                {
                    shareFileModal ?
                        <ProcessingModal 
                            open={shareFileModal} 
                            saving={sharingFiles} 
                            onClose={() => this.onShareModal(false)} 
                            onSuccess={() => this.onShareModalSuccess()}
                            loadingMessage="Please wait while we prepare your download link. It may take few minutes depending on size and number of file(s)."
                            successMessage={ newLinkUploaded === true ? 'Your download link is processing. Please check "Status" in the Link Manager in a few moments. Once "Ready", you may copy the link, and share anywhere.' : 'Your link is now ready to be shared.' }
                            errorMessage={errorMessage}
                            store={this.store}
                        />
                    :
                    <></>
                }
                {
                    downloadModal ?
                        <ProcessingModal 
                            open={downloadModal} 
                            saving={downloadingFiles} 
                            onClose={() => this.onDownloadModal(false)} 
                            onSuccess={() => this.onDownloadModalSuccess()}
                            loadingMessage="Please wait while we prepare your download link. It may take few minutes depending on size and number of file(s)."
                            successMessage="Your files has been processed and your download link is ready."
                            errorMessage={errorMessage}
                            store={this.store}
                        />
                    :
                    <></>
                }
                {
                    newFolderModal ?
                        <NewFolderModal
                            open={newFolderModal}
                            saving={creatingFolder}
                            store={this.store} path={path}
                            onClose={() => this.onNewFolderModal(false)}
                            onSuccess={(folderName) => this.onNewFolderModalSuccess(folderName)}
                            confirmationMessage="Create a folder"
                        />
                    :
                    <></>
                }
                {
                    copyFilesModal ?
                        <CopyFilesModal 
                            open={copyFilesModal} 
                            saving={copyingFilesModal} 
                            onClose={() => this.onCopyModal(false)} 
                            onSuccess={(newPath) => this.onCopyModalSuccess(newPath)}
                            path={path}
                            match={this.props.match}
                            files={checkedFiles}
                            loadingMessage="Please wait while we copy your files. It may take few minutes depending on size of the files."
                            successMessage="Copy your files to new path."
                            errorMessage={errorMessage}
                        />
                    :
                    <></>
                }
                {
                    moveFilesModal ?
                        <MoveFilesModal 
                            open={moveFilesModal} 
                            saving={movingFilesModal} 
                            onClose={() => this.onMoveModal(false)} 
                            onSuccess={(newPath) => this.onMoveModalSuccess(newPath)}
                            path={path}
                            match={this.props.match}
                            files={checkedFiles}
                            loadingMessage="Please wait while we move your files. It may take few minutes depending on size of the files."
                            successMessage="Move your files to new path."
                            errorMessage={errorMessage}
                        />
                    :
                    <></>
                }
                {
                    renameFileModal && checkedFile !== null ?
                        <RenameFileModal 
                            open={renameFileModal} 
                            saving={renamingFileModal} 
                            onClose={() => this.onRenameModal(false)} 
                            onSuccess={(newPath) => this.onRenameModalSuccess(newPath)}
                            file={checkedFile}
                            fileId={fileId}
                            errorMessage={errorMessage}
                        />
                    :
                    <></>
                }
                {
                    newFileModal ?
                        <NewFileModal
                            open={newFileModal}
                            saving={creatingFile}
                            store={this.store} path={path}
                            extension={newFileExtension}
                            onClose={() => this.onNewFileModal(false)}
                            onSuccess={(fileName) => this.onNewFileModalSuccess(fileName)}
                            confirmationMessage="Create new file"
                            error={newFileError}
                            errorMessage={newFileErrorMessage}
                        />
                    :
                    <></>
                }
                {
                    noteModal && checkedFile !== null ?
                        <NoteModal 
                            open={noteModal} 
                            saving={noteSavingModal} 
                            onClose={() => this.onNoteModal(false)} 
                            onSuccess={(note) => this.onNoteModalSuccess(note)}
                            file={checkedFile}
                            errorMessage={errorMessage}
                        />
                    :
                    <></>
                }
                {
                    fileNoteModal && checkedFile !== null ?
                        <FileNoteModal 
                            open={fileNoteModal}
                            onClose={() => this.onFileNoteModal(false)}
                            file={checkedFile}
                            onEdit={() => this.onNoteModal(true)}
                            canEdit={modificationAllowed}
                        />
                    :
                        <></>
                }
                {
                    officeFileModal ?
                        <OfficeFileModal 
                            store={this.store}
                            open={officeFileModal} 
                            action={officeFileAction}
                            file={checkedFile}
                            sharedFileId={fileId}
                            onClose={() => this.onOfficeFileModal(null, false)}
                        />
                    :
                    null
                }
                {
                    imagePreviewModal ?
                        <ImagePreviewModal
                            open={imagePreviewModal}
                            onClose={() => this.onImagePreviewModal(false)}
                            file={checkedFile}
                            onDownload={() => this.onDownloadModal(true)}
                        />
                    :
                    <></>
                }
                {
                    pdfFileModal ?
                        <PdfViewModal 
                            store={this.store}
                            open={pdfFileModal} 
                            file={checkedFile}
                            onClose={() => this.onPdfFileModal(false)}
                            trackPdf={fileId !== '' && canTrackPdf && rootPrivacy === 'write' && (checkedFile.hasOwnProperty('pdf_tracking') && checkedFile.pdf_tracking === 1 ? true : false)}
                            ownerId={ownerId}
                        />
                    :
                    null
                }
                {
                    noPreviewModal ?
                        <NoPreviewModal 
                            store={this.store}
                            open={noPreviewModal} 
                            onDownload={() => this.onDownloadModal(true)}
                            onClose={() => this.onNoPreviewModal(false)}
                        />
                    :
                    null
                }
                {
                    activitiesModal ?
                        <ActivitiesModal
                            store={this.store}
                            open={activitiesModal}
                            onClose={() => this.onActivityModal(false)}
                            activities={activities}
                            activitiesFileId={activitiesFileId}
                        />
                    :
                        <></>
                }
                {
                    pdfTrackingModal ?
                        <ConfirmationModal
                            store={this.store}
                            open={pdfTrackingModal}
                            onClose={() => this.onPdfTrackingModal(false)}
                            onSuccess={() => this.onPdfTrackingModalSuccess()}
                            file={checkedFile}
                            confirmationMessage={
                                checkedFile && checkedFile.pdf_tracking ?
                                    "Are you sure you want to disable PDF tracking for this document?"
                                :
                                    "Are you sure you want to enable PDF tracking for this document?"
                            }
                            saving={this.state.pdfTrackingSavingModal}
                        />
                    :
                        <></>
                }
                <ContextMenu id="file_dropdown_menu" onShow={(e) => this.onContextMenuShow(e)}>
                    {
                        helper.hasThumbnail(checkedFile) ?
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('imagePreview', data, collect)}>
                                <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.625 7.5C5.625 7.10218 5.46696 6.72064 5.18566 6.43934C4.90436 6.15804 4.52282 6 4.125 6C3.72718 6 3.34564 6.15804 3.06434 6.43934C2.78304 6.72064 2.625 7.10218 2.625 7.5C2.625 7.89782 2.78304 8.27936 3.06434 8.56066C3.34564 8.84196 3.72718 9 4.125 9C4.52282 9 4.90436 8.84196 5.18566 8.56066C5.46696 8.27936 5.625 7.89782 5.625 7.5ZM5.42813 9.33516C5.06016 9.59531 4.61016 9.75 4.125 9.75C2.88281 9.75 1.875 8.74219 1.875 7.5C1.875 6.25781 2.88281 5.25 4.125 5.25C5.36719 5.25 6.375 6.25781 6.375 7.5C6.375 7.98516 6.22031 8.43516 5.96016 8.80313L7.01719 9.86016C7.1625 10.0055 7.1625 10.2445 7.01719 10.3898C6.87187 10.5352 6.63281 10.5352 6.4875 10.3898L5.43047 9.33281L5.42813 9.33516ZM8.25 10.5V4.5H5.625C5.00391 4.5 4.5 3.99609 4.5 3.375V0.75H1.5C1.08516 0.75 0.75 1.08516 0.75 1.5V10.5C0.75 10.9148 1.08516 11.25 1.5 11.25H7.5C7.91484 11.25 8.25 10.9148 8.25 10.5ZM8.23828 3.75C8.22188 3.68438 8.18906 3.62344 8.13984 3.57656L5.42344 0.860156C5.37422 0.810938 5.31563 0.778125 5.25 0.761719V3.375C5.25 3.58125 5.41875 3.75 5.625 3.75H8.23828ZM0 1.5C0 0.672656 0.672656 0 1.5 0H5.15859C5.45625 0 5.74219 0.119531 5.95312 0.330469L8.66953 3.04453C8.88047 3.25547 9 3.54141 9 3.83906V10.5C9 11.3273 8.32734 12 7.5 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5Z" />
                                </svg>
                                Preview
                            </MenuItem>
                        :   
                            <></>
                    }
                    {
                        helper.isPdfDocument(checkedFile) ?
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('pdfPreview', data, collect)}>
                                <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.625 7.5C5.625 7.10218 5.46696 6.72064 5.18566 6.43934C4.90436 6.15804 4.52282 6 4.125 6C3.72718 6 3.34564 6.15804 3.06434 6.43934C2.78304 6.72064 2.625 7.10218 2.625 7.5C2.625 7.89782 2.78304 8.27936 3.06434 8.56066C3.34564 8.84196 3.72718 9 4.125 9C4.52282 9 4.90436 8.84196 5.18566 8.56066C5.46696 8.27936 5.625 7.89782 5.625 7.5ZM5.42813 9.33516C5.06016 9.59531 4.61016 9.75 4.125 9.75C2.88281 9.75 1.875 8.74219 1.875 7.5C1.875 6.25781 2.88281 5.25 4.125 5.25C5.36719 5.25 6.375 6.25781 6.375 7.5C6.375 7.98516 6.22031 8.43516 5.96016 8.80313L7.01719 9.86016C7.1625 10.0055 7.1625 10.2445 7.01719 10.3898C6.87187 10.5352 6.63281 10.5352 6.4875 10.3898L5.43047 9.33281L5.42813 9.33516ZM8.25 10.5V4.5H5.625C5.00391 4.5 4.5 3.99609 4.5 3.375V0.75H1.5C1.08516 0.75 0.75 1.08516 0.75 1.5V10.5C0.75 10.9148 1.08516 11.25 1.5 11.25H7.5C7.91484 11.25 8.25 10.9148 8.25 10.5ZM8.23828 3.75C8.22188 3.68438 8.18906 3.62344 8.13984 3.57656L5.42344 0.860156C5.37422 0.810938 5.31563 0.778125 5.25 0.761719V3.375C5.25 3.58125 5.41875 3.75 5.625 3.75H8.23828ZM0 1.5C0 0.672656 0.672656 0 1.5 0H5.15859C5.45625 0 5.74219 0.119531 5.95312 0.330469L8.66953 3.04453C8.88047 3.25547 9 3.54141 9 3.83906V10.5C9 11.3273 8.32734 12 7.5 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5Z" />
                                </svg>
                                Preview
                            </MenuItem>
                        :   
                            <></>
                    }
                    {
                        helper.isExtensionAllowed(user, 'ms_office') && helper.isExtensionEnable(user, 'ms_office') && helper.isOfficeDocument(checkedFile) ?
                            <>
                                <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('view', data, collect)}>
                                    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.625 7.5C5.625 7.10218 5.46696 6.72064 5.18566 6.43934C4.90436 6.15804 4.52282 6 4.125 6C3.72718 6 3.34564 6.15804 3.06434 6.43934C2.78304 6.72064 2.625 7.10218 2.625 7.5C2.625 7.89782 2.78304 8.27936 3.06434 8.56066C3.34564 8.84196 3.72718 9 4.125 9C4.52282 9 4.90436 8.84196 5.18566 8.56066C5.46696 8.27936 5.625 7.89782 5.625 7.5ZM5.42813 9.33516C5.06016 9.59531 4.61016 9.75 4.125 9.75C2.88281 9.75 1.875 8.74219 1.875 7.5C1.875 6.25781 2.88281 5.25 4.125 5.25C5.36719 5.25 6.375 6.25781 6.375 7.5C6.375 7.98516 6.22031 8.43516 5.96016 8.80313L7.01719 9.86016C7.1625 10.0055 7.1625 10.2445 7.01719 10.3898C6.87187 10.5352 6.63281 10.5352 6.4875 10.3898L5.43047 9.33281L5.42813 9.33516ZM8.25 10.5V4.5H5.625C5.00391 4.5 4.5 3.99609 4.5 3.375V0.75H1.5C1.08516 0.75 0.75 1.08516 0.75 1.5V10.5C0.75 10.9148 1.08516 11.25 1.5 11.25H7.5C7.91484 11.25 8.25 10.9148 8.25 10.5ZM8.23828 3.75C8.22188 3.68438 8.18906 3.62344 8.13984 3.57656L5.42344 0.860156C5.37422 0.810938 5.31563 0.778125 5.25 0.761719V3.375C5.25 3.58125 5.41875 3.75 5.625 3.75H8.23828ZM0 1.5C0 0.672656 0.672656 0 1.5 0H5.15859C5.45625 0 5.74219 0.119531 5.95312 0.330469L8.66953 3.04453C8.88047 3.25547 9 3.54141 9 3.83906V10.5C9 11.3273 8.32734 12 7.5 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5Z" />
                                    </svg>
                                    Preview
                                </MenuItem>
                                {
                                    canEdit ?
                                        <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('edit', data, collect)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="1064.000000pt" height="1281.000000pt" viewBox="0 0 1064.000000 1281.000000" preserveAspectRatio="xMidYMid meet">
                                                <g transform="translate(0.000000,1281.000000) scale(0.100000,-0.100000)" stroke="none">
                                                    <path d="M6800 12775 c-47 -19 -413 -155 -815 -303 -698 -258 -1343 -497 -2770 -1024 -1731 -640 -2121 -784 -2642 -976 l-563 -207 0 -3892 0 -3892 68 30 c37 17 220 97 407 179 378 164 928 405 1370 599 160 70 347 152 417 182 l127 54 3 3070 3 3070 370 86 c204 48 719 168 1145 267 426 100 989 231 1250 292 261 61 743 174 1070 250 327 76 607 141 623 145 l27 7 0 -4531 0 -4531 -27 5 c-16 3 -554 68 -1198 146 -643 77 -1224 147 -1290 155 -2127 257 -4341 522 -4342 520 -2 -2 207 -78 465 -171 257 -92 514 -185 572 -206 58 -21 276 -99 485 -174 209 -75 553 -199 765 -275 212 -76 610 -219 885 -318 275 -99 732 -263 1015 -365 283 -102 684 -246 890 -320 206 -74 553 -199 770 -277 405 -145 499 -179 820 -295 171 -62 188 -66 225 -57 22 6 863 258 1868 561 1005 303 1830 551 1832 551 3 0 4 2359 3 5241 l-3 5242 -840 269 c-462 147 -930 297 -1040 332 -110 35 -357 114 -550 176 -192 62 -417 134 -500 160 -82 26 -294 94 -469 150 -176 56 -324 103 -330 105 -6 2 -49 -12 -96 -30z"/>
                                                </g>
                                            </svg>
                                            Open in Office web
                                        </MenuItem>
                                    :
                                        null
                                }
                            </>
                        :
                            null
                    }
                    {
                        path === '/' && ownerId === user.id && sharedWith !== null && sharedWith.length > 0 ?
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('permission', data, collect)}>
                                <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.99956 2.99956C2.99956 2.70413 3.05775 2.41159 3.17081 2.13865C3.28386 1.86571 3.44957 1.6177 3.65847 1.4088C3.86738 1.1999 4.11538 1.03419 4.38832 0.921136C4.66126 0.80808 4.9538 0.74989 5.24923 0.74989C5.54466 0.74989 5.8372 0.80808 6.11014 0.921136C6.38309 1.03419 6.63109 1.1999 6.83999 1.4088C7.04889 1.6177 7.2146 1.86571 7.32766 2.13865C7.44071 2.41159 7.4989 2.70413 7.4989 2.99956C7.4989 3.29499 7.44071 3.58753 7.32766 3.86047C7.2146 4.13341 7.04889 4.38142 6.83999 4.59032C6.63109 4.79922 6.38309 4.96493 6.11014 5.07799C5.8372 5.19104 5.54466 5.24923 5.24923 5.24923C4.9538 5.24923 4.66126 5.19104 4.38832 5.07799C4.11538 4.96493 3.86738 4.79922 3.65847 4.59032C3.44957 4.38142 3.28386 4.13341 3.17081 3.86047C3.05775 3.58753 2.99956 3.29499 2.99956 2.99956ZM8.24879 2.99956C8.24879 2.20403 7.93277 1.44108 7.37024 0.878551C6.80771 0.316024 6.04476 0 5.24923 0C4.4537 0 3.69075 0.316024 3.12822 0.878551C2.56569 1.44108 2.24967 2.20403 2.24967 2.99956C2.24967 3.79509 2.56569 4.55804 3.12822 5.12057C3.69075 5.6831 4.4537 5.99912 5.24923 5.99912C6.04476 5.99912 6.80771 5.6831 7.37024 5.12057C7.93277 4.55804 8.24879 3.79509 8.24879 2.99956ZM0.74989 11.2484C0.778011 9.38066 2.30123 7.87385 4.17829 7.87385H6.32017C6.77479 7.87385 7.20832 7.9629 7.6067 8.12225C7.55514 7.83167 7.52468 7.5528 7.51062 7.29502C7.13333 7.18254 6.73495 7.12396 6.32251 7.12396H4.18064C1.87004 7.12396 0 8.99399 0 11.3022C0 11.6866 0.311673 11.9982 0.695992 11.9982H9.80247C9.84465 11.9982 9.88449 11.9936 9.92667 11.9865C9.61265 11.7592 9.33848 11.5108 9.09476 11.2484H0.74989ZM8.99868 7.06303L11.2484 6.16316V11.0468C9.52829 10.0977 9.03149 8.30269 9.00103 7.06303H8.99868ZM14.2456 7.06303C14.2151 8.30503 13.716 10.0977 11.9982 11.0468V6.16316L14.2456 7.06303ZM11.8319 5.28907C11.6983 5.23517 11.5483 5.23517 11.4147 5.28907L8.60265 6.4139C8.3894 6.50061 8.24879 6.70683 8.24879 6.93648C8.24879 8.41986 8.85573 10.8922 11.4077 11.9561C11.546 12.0146 11.703 12.0146 11.8412 11.9561C14.3909 10.8922 14.9978 8.41986 14.9978 6.93648C14.9978 6.70683 14.8572 6.50061 14.6439 6.4139L11.8319 5.28907Z" />
                                </svg>
                                Permissions
                            </MenuItem>
                        :
                            <></>
                    }
                    {
                        modificationAllowed ?
                            user.level_id !== 5 ?
                                <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('share', data, collect)}>
                                    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.92857 3.42896C8.28482 3.42896 8.57143 3.14236 8.57143 2.78613V2.57185V2.1433V0.857644L12.8571 4.71461L8.57143 8.57158V7.28593V6.85737V6.6431C8.57143 6.28686 8.28482 6.00027 7.92857 6.00027H7.71429H5.14286C3.24911 6.00027 1.71429 7.53502 1.71429 9.42869C1.71429 9.651 1.73304 9.85992 1.76786 10.0501C1.28304 9.42065 0.857143 8.52069 0.857143 7.28593C0.857143 5.15656 2.58482 3.42896 4.71429 3.42896H7.71429H7.92857ZM7.71429 7.28593V7.71448V8.57158C7.71429 8.90907 7.9125 9.21709 8.22321 9.35369C8.53393 9.49029 8.89286 9.43404 9.14464 9.20905L13.4304 5.35208C13.6098 5.1887 13.7143 4.95835 13.7143 4.71461C13.7143 4.47087 13.6125 4.24053 13.4304 4.07714L9.14464 0.220173C8.89286 -0.00749573 8.53125 -0.0637432 8.22321 0.0755362C7.91518 0.214816 7.71429 0.520159 7.71429 0.857644V1.71475V2.1433V2.57185H6.85714H4.71429C2.11071 2.57185 0 4.68247 0 7.28593C0 10.3206 2.18304 11.6759 2.68393 11.9491C2.75089 11.9866 2.82589 12 2.90089 12C3.19286 12 3.42857 11.7616 3.42857 11.4723C3.42857 11.2715 3.31339 11.0866 3.16607 10.95C2.91429 10.7117 2.57143 10.2429 2.57143 9.42869C2.57143 8.00911 3.72321 6.85737 5.14286 6.85737H6.85714H7.71429V7.28593Z" />
                                    </svg>
                                    Share
                                </MenuItem>
                            :
                                <></>
                        :
                            <></>
                    }
                    {
                        modificationAllowed ?
                            <div className={"border-bottom"}></div>
                        :
                            <></>
                    }
                    {
                        modificationAllowed ?
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('delete', data, collect)}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.49539 0.75H6.83542C6.97455 0.75 7.10357 0.815625 7.17946 0.925781L7.56652 1.5H3.76682L4.15387 0.925781C4.22723 0.815625 4.35878 0.75 4.49792 0.75H4.49539ZM8.52277 1.5L7.86756 0.529688C7.64494 0.199219 7.25536 0 6.83795 0H4.49539C4.07798 0 3.68839 0.199219 3.46577 0.529688L2.81057 1.5H1.62158H0.809524H0.404762C0.182143 1.5 0 1.66875 0 1.875C0 2.08125 0.182143 2.25 0.404762 2.25H0.867708L1.5128 10.6078C1.57098 11.393 2.27679 12 3.12679 12H8.20655C9.05655 12 9.75982 11.393 9.82054 10.6078L10.4656 2.25H10.9286C11.1512 2.25 11.3333 2.08125 11.3333 1.875C11.3333 1.66875 11.1512 1.5 10.9286 1.5H10.5238H9.71175H8.52277ZM9.6561 2.25L9.01354 10.5539C8.98318 10.9453 8.63155 11.25 8.20655 11.25H3.12679C2.70179 11.25 2.35015 10.9453 2.31979 10.5539L1.67976 2.25H9.65357H9.6561Z" />
                                </svg>
                                Delete
                            </MenuItem>
                        :
                            <></>
                    }
                    {
                        this.isDownloadAllowed() ?
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('download', data, collect)}>
                                <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.51484 5.13984L5.51484 8.13984C5.36953 8.28516 5.13047 8.28516 4.98516 8.13984L1.98516 5.13984C1.83984 4.99453 1.83984 4.75547 1.98516 4.61016C2.13047 4.46484 2.36953 4.46484 2.51484 4.61016L4.875 6.97031V0.375C4.875 0.16875 5.04375 0 5.25 0C5.45625 0 5.625 0.16875 5.625 0.375V6.97031L7.98516 4.61016C8.13047 4.46484 8.36953 4.46484 8.51484 4.61016C8.66016 4.75547 8.66016 4.99453 8.51484 5.13984ZM0.75 7.875V10.125C0.75 10.7461 1.25391 11.25 1.875 11.25H8.625C9.24609 11.25 9.75 10.7461 9.75 10.125V7.875C9.75 7.66875 9.91875 7.5 10.125 7.5C10.3313 7.5 10.5 7.66875 10.5 7.875V10.125C10.5 11.1609 9.66094 12 8.625 12H1.875C0.839062 12 0 11.1609 0 10.125V7.875C0 7.66875 0.16875 7.5 0.375 7.5C0.58125 7.5 0.75 7.66875 0.75 7.875Z" />
                                </svg>
                                Download
                            </MenuItem>
                        :
                            <></>
                    }
                    {
                        modificationAllowed ?
                        <>
                            {
                                user.level_id !== 5 && path !== '/' ?
                                    <>
                                        <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('copy', data, collect)}>
                                            <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 8.25H5.25C4.83516 8.25 4.5 7.91484 4.5 7.5V1.5C4.5 1.08516 4.83516 0.75 5.25 0.75H7.78359C7.88203 0.75 7.97812 0.789844 8.04844 0.860156L9.63984 2.45156C9.71016 2.52187 9.75 2.61797 9.75 2.71641V7.5C9.75 7.91484 9.41484 8.25 9 8.25ZM10.1695 1.91953L8.58047 0.330469C8.36953 0.119531 8.08359 0 7.78594 0H5.25C4.42266 0 3.75 0.672656 3.75 1.5V7.5C3.75 8.32734 4.42266 9 5.25 9H9C9.82734 9 10.5 8.32734 10.5 7.5V2.71641C10.5 2.41875 10.3805 2.13281 10.1695 1.92188V1.91953ZM1.5 3C0.672656 3 0 3.67266 0 4.5V10.5C0 11.3273 0.672656 12 1.5 12H5.25C6.07734 12 6.75 11.3273 6.75 10.5V9.75H6V10.5C6 10.9148 5.66484 11.25 5.25 11.25H1.5C1.08516 11.25 0.75 10.9148 0.75 10.5V4.5C0.75 4.08516 1.08516 3.75 1.5 3.75H3V3H1.5Z" />
                                            </svg>
                                            Copy
                                        </MenuItem>
                                        <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('move', data, collect)}>
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.25 10.5C11.25 10.9148 10.9148 11.25 10.5 11.25H4.5C4.08516 11.25 3.75 10.9148 3.75 10.5V8.625H3V10.5C3 11.3273 3.67266 12 4.5 12H10.5C11.3273 12 12 11.3273 12 10.5V3.84141C12 3.54375 11.8805 3.25781 11.6695 3.04688L8.95547 0.330469C8.74453 0.119531 8.45859 0 8.16094 0H4.5C3.67266 0 3 0.672656 3 1.5V6H3.75V1.5C3.75 1.08516 4.08516 0.75 4.5 0.75H7.5V3.375C7.5 3.99609 8.00391 4.5 8.625 4.5H11.25V10.5ZM11.2383 3.75H8.625C8.41875 3.75 8.25 3.58125 8.25 3.375V0.761719C8.31563 0.778125 8.37656 0.810938 8.42344 0.860156L11.1398 3.57656C11.1891 3.62578 11.2219 3.68438 11.2383 3.75ZM6.63984 4.98516C6.49453 4.83984 6.25547 4.83984 6.11016 4.98516C5.96484 5.13047 5.96484 5.36953 6.11016 5.51484L7.72031 7.125H0.375C0.16875 7.125 0 7.29375 0 7.5C0 7.70625 0.16875 7.875 0.375 7.875H7.72031L6.11016 9.48516C5.96484 9.63047 5.96484 9.86953 6.11016 10.0148C6.25547 10.1602 6.49453 10.1602 6.63984 10.0148L8.88984 7.76484C9.03516 7.61953 9.03516 7.38047 8.88984 7.23516L6.63984 4.98516Z" />
                                            </svg>
                                            Move
                                        </MenuItem>
                                    </>
                                :
                                   <></>
                            }
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('rename', data, collect)}>
                                <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 1.54688C2.48906 0.623437 1.50469 0 0.375 0H0V0.75H0.375C1.61719 0.75 2.625 1.75781 2.625 3V5.625H1.5H1.125V6.375H1.5H2.625V9C2.625 10.2422 1.61719 11.25 0.375 11.25H0V12H0.375C1.50469 12 2.48906 11.3766 3 10.4531C3.51094 11.3766 4.49531 12 5.625 12H6V11.25H5.625C4.38281 11.25 3.375 10.2422 3.375 9V6.375H4.5H4.875V5.625H4.5H3.375V3C3.375 1.75781 4.38281 0.75 5.625 0.75H6V0H5.625C4.49531 0 3.51094 0.623437 3 1.54688Z" />
                                </svg>
                                Rename
                            </MenuItem>
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('note', data, collect)}>
                                <MaterialIcon path={mdiMessageOutline} className="MuiSvgIcon-root" />
                                {
                                    currentFile !== null && currentFile.note && currentFile.note !== null ?
                                        <>Edit note</>
                                    :
                                        <>Add a note</>
                                }
                            </MenuItem>
                            {
                                helper.isPdfDocument(checkedFile) && ownerId === user.id && helper.isExtensionEnable(user, 'pdf_track') ?
                                    <>
                                        {
                                            currentFile !== null && currentFile.hasOwnProperty('pdf_tracking') && currentFile.pdf_tracking === 1 ?
                                                <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('pdfTracking', data, collect)}>
                                                    <AssessmentOutlined />
                                                    Disable PDF Analytics
                                                </MenuItem>
                                            :
                                                <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('pdfTracking', data, collect)}>
                                                    <AssessmentOutlined />
                                                    Enable PDF Analytics
                                                </MenuItem>
                                        }
                                        <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('pdfActivity', data, collect)}>
                                            <AssessmentOutlined />
                                            View Activity
                                        </MenuItem>
                                    </>
                                :   
                                    <></>
                            }
                        </>
                        :
                        <></>
                    }
                </ContextMenu>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    className={classes.snackbar}
                    open={showError}
                    autoHideDuration={10000}
                    onClose={this.closeSnackbar}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={
                        <div className={classes.snackErrorMessage}>{this.renderErrorMessages()}</div>
                    }
                    action={[
                    <IconButton
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        className={classes.close}
                        onClick={this.closeSnackbar}
                    >
                        <CloseIcon />
                    </IconButton>,
                    ]}
                />
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE}</title>
                    {
                        officeFileModal === false ?
                            <link rel="shortcut icon" href="favicon.ico" />
                        :
                        null
                    }
                </Helmet>
                {
                    fileId ?
                        <form ref={this.editDocRef} target='_blank' method='GET' style={{display: 'none'}}>
                            {/* <input ref={this.editDocTokenRef} name="oauth-token" type="hidden" /> */}
                            <input name="sharedFile" type="hidden" value={fileId} />
                        </form>
                    :
                        <></>
                }
            </div>
        )
    }
}

UserShared.propTypes = {
    classes: PropTypes.object
};

export default withStyles(userHomePageStyle)(UserShared);
